<template>
	<div class="container-fluid">
		<Clist :regresar="regresar"
			:Nombre="Titulo"
			@FiltrarC="Lista"
			:Filtro="Filtro"
			:isModal="EsModal"
			:pShowBtnAdd="false"
			:pConfigLoad="ConfigLoad"
			:isHistorialEquipo="true"
			:ShowPager="ShowPager"
			:ShowFilas="false"
			:ShowBusqueda="ShowBusqueda">
			<template slot="DatosEquipo">
				<!-- <input type="hidden" :value="setLocation"> -->
				<div class="col-lg-12 mb-1">
					<div class="row">
						<div class="col-lg-2">
							<div class="avatar-upload-histequipo">
								<div class="avatar-edit">
									<input id="file" @change="CambiarImagenProyecto($event)" ref="file" type="file" name="file" accept=".png, .jpg, .jpeg">
									<label for="file"></label>
								</div>
								<div class="avatar-edit2">
									<button type="button" data-backdrop="static"
									data-toggle="modal"
									data-target="#imagen" @click="ZoomImagen(Proyecto.Imagen,1)">
										<i class="fas fa-search"></i>
									</button>
								</div>
								<div v-if="BndImagen!=0" class="avatar-edit3">
									<button type="button" @click="GuardarImagen">
										<i class="fas fa-save"></i>
									</button>
								</div>
								<div class="avatar-preview">
									<div id="imagePreview" :style="'background-image: url('+Proyecto.Imagen+');'" :src="Proyecto.Imagen">
									</div>
								</div>
							</div>
							<div v-if="BndImagen!=0">
								<p class="text-danger text-leyenda">Aún no sube la imagen, presione guardar para subirla</p>
							</div>
						</div>
						<div class="col-lg-2">
							<div class="row">
								<div class="col-lg-4 pr-0">
									<span class="titulosmonitoreo">Cliente: </span>
								</div>
								<div class="col-lg-8 pl-1">
									<span v-b-tooltip.hover.top :title="Proyecto.Cliente" class="text-info titulosmonitoreo">{{ $limitCharacters(Proyecto.Cliente,18) }}</span>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-4 pr-0">
									<span class="titulosmonitoreo">Propiedad: </span>
								</div>
								<div class="col-lg-8 pl-1">
									<span v-b-tooltip.hover.top :title="Proyecto.Propiedad" class="text-info titulosmonitoreo">{{ $limitCharacters(Proyecto.Propiedad,18) }}</span>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-4 pr-0">
									<span class="titulosmonitoreo">Contrato: </span>
								</div>
								<div class="col-lg-8 pl-1">
									<span v-b-tooltip.hover.top :title="Proyecto.Contrato" class="text-info titulosmonitoreo">{{ $limitCharacters(Proyecto.Contrato,18) }}</span>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-4 pr-0">
									<span class="titulosmonitoreo">Dirección: </span>
								</div>
								<div class="col-lg-8 pl-1">
									<span v-b-tooltip.hover.top :title="Proyecto.Direccion" class="text-info titulosmonitoreo">{{ $limitCharacters(Proyecto.Direccion,18) }}</span>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-4 pr-0">
									<span class="titulosmonitoreo">Ciudad: </span>
								</div>
								<div class="col-lg-8 pl-1">
									<span v-b-tooltip.hover.top :title="Proyecto.Ciudad" class="text-info titulosmonitoreo">{{ $limitCharacters(Proyecto.Ciudad,18) }}</span>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-4 pr-0">
									<span class="titulosmonitoreo">P.M.: </span>
								</div>
								<div class="col-lg-8 pl-1">
									<span v-b-tooltip.hover.top :title="Proyecto.ProjectManager" class="text-info titulosmonitoreo">{{ $limitCharacters(Proyecto.ProjectManager,18) }}</span>
								</div>
							</div>
							<div class="row">
								<div class="col-lg-4 pr-0">
									<span class="titulosmonitoreo">Residente: </span>
								</div>
								<div class="col-lg-8 pl-1">
									<span v-b-tooltip.hover.top :title="Proyecto.Residente" class="text-info titulosmonitoreo">{{ $limitCharacters(Proyecto.Residente,18) }}</span>
								</div>
							</div>
						</div>
						<div class="col-lg-4">
							<!-- <span class="titulosmonitoreo">Fechas</span>
							<br> -->
							<div class="row">
								<div class="col-lg-5 pr-0">
									<div class="row">
										<div class="col-lg-6 pr-0">
											<span class="titulosmonitoreo">Inicio Contrato: </span>
										</div>
										<div class="col-lg-6 pl-1">
											<span class="text-info titulosmonitoreo">{{ $getCleanDate(Proyecto.InicioContrato,false) }}</span>
										</div>
									</div>
									<div class="row">
										<div class="col-lg-6 pr-0">
											<span class="titulosmonitoreo">Inicio Real: </span>
										</div>
										<div class="col-lg-6 pl-1">
											<span class="text-info titulosmonitoreo">{{ $getCleanDate(Proyecto.FechaInicio,false) }}</span>
										</div>
									</div>
								</div>
								<div class="col-lg-6 pl-0">
									<div class="row">
										<div class="col-lg-6 pr-0">
											<span class="titulosmonitoreo">Término Contrato: </span>
										</div>
										<div class="col-lg-6 pl-1">
											<span class="text-info titulosmonitoreo">{{ $getCleanDate(Proyecto.TerminoContrato,false) }}</span>
										</div>
									</div>
									<div class="row">
										<div class="col-lg-6 pr-0">
											<span class="titulosmonitoreo">Término Real: </span>
										</div>
										<div class="col-lg-6 pl-1">
											<span class="text-info titulosmonitoreo">{{ $getCleanDate(Proyecto.FechaFin,false) }}</span>
										</div>
									</div>
								</div>
							</div>
							<!-- <div class="row mt-4">
								<div class="col-lg-12">
									<div class="row">
										<div class="col-lg-8 pr-0">
											<span class="titulosmonitoreo" style="font-size:22px">Utilidad Actual: </span>
										</div>
										<div class="col-lg-4 pl-1">
											<span style="font-size:22px" :class="EvalUtilidadActual(UtilidadActual)">{{ UtilidadActual }} %</span>
										</div>
									</div>
								</div>
							</div> -->
							<div class="row mt-4">
								<div class="col-lg-12">
									<span class="titulosmonitoreo mr-2" style="font-size:22px">Utilidad Actual: </span>
									<span style="font-size:22px" :class="EvalUtilidadActual(UtilidadActual)">{{ UtilidadActual }} %</span>
								</div>
							</div>
							<div class="row mt-4">
								<div class="col-lg-4">
									<button @click="Calendario" class="btn btn-pink" type="button"><i class="fa fa-calendar-alt"></i> Ir a Programa</button>
								</div>
								<div class="col-lg-4">
									<button @click="IrSpendPlan" class="btn btn-pink" type="button"><i class="fa fa-calculator"></i> Ir a Spend Plan</button>
								</div>
								<div class="col-lg-4">
									<button @click="IrDashboard" class="btn btn-pink" type="button"><i class="fa fa-chart-pie"></i> Ir a Dashboard</button>
								</div>
							</div>
						</div>
						<div class="col-lg-2">
							<div class="card card-body card-sombra-fuerte pt-2 pb-2">
								<h3 class="bold">Venta</h3>
								<h2 class="text-center bold">$ {{formateoMillon(parseFloat(ValoresCard.Venta))}}</h2>
								<h3 class="text-center text-info bold">{{ValoresCard.VentaPorcen}} %</h3>
							</div>
							<br>
							<div class="card card-body card-sombra-fuerte pt-2 pb-2">
								<h3 class="bold">Retención</h3>
								<h2 class="text-center bold">$ {{formateoMillon(parseFloat(ValoresCard.Retencion))}}</h2>
								<h3 class="text-center text-info bold">{{ValoresCard.RetencionPorcen}} %</h3>
							</div>
						</div>
						<div class="col-lg-2">
							<div class="card card-body card-sombra-fuerte pt-2 pb-2">
								<h3 class="bold">Costo Operativo Plan</h3>
								<h2 class="text-center bold">$ {{formateoMillon(parseFloat(ValoresCard.CostoOperativo))}}</h2>
								<h3 class="text-center text-info bold">{{ValoresCard.CostoOperativoPorcen}} %</h3>
							</div>
							<br>
							<div class="card card-body card-sombra-fuerte pt-2 pb-2">
								<h3 class="bold">Facturado YTD</h3>
								<h2 class="text-center bold">$ {{formateoMillon(parseFloat(ValoresCard.Facturado))}}</h2>
								<h3 class="text-center text-info bold">{{ValoresCard.FacturadoPorcen}} %</h3>
							</div>
						</div>
						<!-- <div class="col-lg-2 mx-auto mt-4">
							<div v-if="ShowGraficaProgreso" id="chart" class="position-absolute">
								<apexchart type="radialBar" height="300" :options="ProgresoGraph" :series="SeriesProgreso"></apexchart>
							</div>
						</div>
						<div class="col-lg-2 mx-auto mt-4">
							<div v-if="ShowGraficaPresupuesto" id="chart" class="position-absolute">
								<apexchart type="radialBar" height="300" :options="PresupuestoGraph" :series="SeriesPresupuesto"></apexchart>
							</div>
						</div> -->
					</div>
					<div class="row mt-4">
						<!-- <div class="col-lg-2">
							<div class="card card-body card-sombra-fuerte pt-2 pb-2">
								<h3 class="bold">Venta</h3>
								<h2 class="text-center bold">$ {{formateoMillon(parseFloat(ValoresCard.Venta))}}</h2>
								<h3 class="text-center text-info bold">{{ValoresCard.VentaPorcen}} %</h3>
							</div>
						</div>
						<div class="col-lg-2">
							<div class="card card-body card-sombra-fuerte pt-2 pb-2">
								<h3 class="bold">Costo Operativo Plan</h3>
								<h2 class="text-center bold">$ {{formateoMillon(parseFloat(ValoresCard.CostoOperativo))}}</h2>
								<h3 class="text-center text-info bold">{{ValoresCard.CostoOperativoPorcen}} %</h3>
							</div>
						</div>
						<div class="col-lg-2">
							<div class="card card-body card-sombra-fuerte pt-2 pb-2">
								<h3 class="bold">Facturado YTD</h3>
								<h2 class="text-center bold">$ {{formateoMillon(parseFloat(ValoresCard.Facturado))}}</h2>
								<h3 class="text-center text-info bold">{{ValoresCard.FacturadoPorcen}} %</h3>
							</div>
						</div>
						<div class="col-lg-2">
							<div class="card card-body card-sombra-fuerte pt-2 pb-2">
								<h3 class="bold">Retención</h3>
								<h2 class="text-center bold">$ {{formateoMillon(parseFloat(ValoresCard.Retencion))}}</h2>
								<h3 class="text-center text-info bold">{{ValoresCard.RetencionPorcen}} %</h3>
							</div>
						</div> -->
						<!-- <div class="col-lg-2">
							<div class="card card-body card-sombra-fuerte pt-2 pb-2">
								<h3 class="bold">Estimaciones YTD</h3>
								<h2 class="text-center bold">$ {{formateoMillon(parseFloat(ValoresCard.Estimado))}}</h2>
								<h3 class="text-center text-info bold">{{ValoresCard.EstimadoPorcen}} %</h3>
							</div>
						</div> -->
						<!-- <div class="col-lg-2">
							<div class="card card-body card-sombra-fuerte pt-2 pb-2">
								<h3 class="bold">Cobrado YTD</h3>
								<h2 class="text-center bold"><span :class="ComparacionCifrasColor(ValoresCard.Facturado,ValoresCard.Cobrado)">$ {{formateoMillon(parseFloat(ValoresCard.Cobrado))}}</span></h2>
								<h3 class="text-center text-info bold">{{ValoresCard.CobradoPorcen}} %</h3>
							</div>
						</div> -->
						<!-- <div class="col-lg-2">
							<div class="card card-body card-sombra-fuerte pt-2 pb-2">
								<h3 class="bold">Gasto Operativo YTD</h3>
								<h2 class="text-center bold"><span :class="ComparacionCifrasColor(ValoresCard.CostoOperativo,ValoresCard.GastoOp)">$ {{formateoMillon(parseFloat(ValoresCard.GastoOp))}}</span></h2>
								<h3 class="text-center text-info bold">{{ValoresCard.GastoOpPorcen}} %</h3>
							</div>
						</div> -->
					</div>
					<div class="row mb-2 mt-3">
						<div class="form-inline">
							<!-- <button @click="CambiarPestania('Contratos')" type="button" :class="Botones.Contratos ? 'btn btn-06 text-info bold' : 'btn btn-06 text-dark bold'">Contratos</button> -->
							<button @click="CambiarPestania('Facturacion')" type="button" :class="Botones.Facturacion ? 'btn btn-06 text-info bold' : 'btn btn-06 text-dark bold'">Facturación</button>
							<button @click="CambiarPestania('Compras')" type="button" :class="Botones.Compras ? 'btn btn-06 text-info bold' : 'btn btn-06 text-dark bold'">Compras</button>
							<button @click="CambiarPestania('Estimaciones')" type="button" :class="Botones.Estimaciones ? 'btn btn-06 text-info bold' : 'btn btn-06 text-dark bold'">Estimaciones</button>
							<button @click="CambiarPestania('Adicionales')" type="button" :class="Botones.Adicionales ? 'btn btn-06 text-info bold' : 'btn btn-06 text-dark bold'">Adicionales</button>
							<!-- <button @click="CambiarPestania('RFI')" type="button" :class="Botones.RFI ? 'btn btn-06 text-info bold' : 'btn btn-06 text-dark bold'">RFIs</button> -->
							<button @click="CambiarPestania('ReporteObra')" type="button" :class="Botones.ReporteObra ? 'btn btn-06 text-info bold' : 'btn btn-06 text-dark bold'">Reporte Obra</button>
							<button @click="CambiarPestania('Propuestas')" type="button" :class="Botones.Propuestas ? 'btn btn-06 text-info bold' : 'btn btn-06 text-dark bold'">Propuestas</button>
							<button @click="CambiarPestania('Personal')" type="button" :class="Botones.Personal ? 'btn btn-06 text-info bold' : 'btn btn-06 text-dark bold'">Personal</button>
							<button @click="CambiarPestania('Servicios')" type="button" :class="Botones.Servicios ? 'btn btn-06 text-info bold' : 'btn btn-06 text-dark bold'">Servicios</button>
							<!-- <button @click="CambiarPestania('Garantias')" type="button" :class="Botones.Garantias ? 'btn btn-06 text-info bold' : 'btn btn-06 text-dark bold'">Garantías</button> -->
							<button @click="CambiarPestania('Documentos')" type="button" :class="Botones.Documentos ? 'btn btn-06 text-info bold' : 'btn btn-06 text-dark bold'">Documentación</button>
							<button @click="CambiarPestania('Planos')" type="button" :class="Botones.Planos ? 'btn btn-06 text-info bold' : 'btn btn-06 text-dark bold'">Planos</button>
							<button @click="CambiarPestania('Materiales')" type="button" :class="Botones.Materiales ? 'btn btn-06 text-info bold' : 'btn btn-06 text-dark bold'">Materiales</button>
							<button @click="CambiarPestania('Equipos')" type="button" :class="Botones.Equipos ? 'btn btn-06 text-info bold' : 'btn btn-06 text-dark bold'">Equipos</button>
						</div>
					</div>
				</div>
			</template>
			<template v-if="Botones.Contratos" slot="header">
				<tr>
					<th>Nombre Contrato</th>
					<th>Tipo Contrato</th>
					<th>Trabajo</th>
					<th>Valor</th>
					<th>Fecha Inicio</th>
					<th>Fecha Termino</th>
					<th>Facturación</th>
					<th>Comentarios</th>
					<th>Documentos</th>
					<th>Estatus</th>
					<th>Acciones</th>
				</tr>
			</template>
			<template slot="body" v-if="Botones.Contratos">
				<tr v-for="(item,index) in ListContratos" :key="index">
					<td>{{item.NumeroC}}</td>
					<td>{{item.TipoContrato}}</td>
					<td>{{EvalConfigS(item.IdConfigS)}}</td>
					<td>$ {{formateoMillon(parseFloat(item.Valor))}}</td>
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.FechaInicio,false)}}</td>
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.FechaTermino,false)}}</td>
					<td>{{EvalNumPagos(item.Facturacion)}}</td>
					<td>{{$limitCharacters(item.Comentario,50)}}</td>
					<td>
						<button v-if="item.Archivo!='' && item.Archivo !=null" @click="AbrirPdf(RutaPdfContrato + item.Archivo)" title="Ver Documento" class="btn-icon mr-2"><i class="fa fa-file-pdf"></i></button>
                    	<span v-else>No Contiene Archivo</span>
					</td>
					<td>{{item.Estatus}}</td>
					<td>
                        <Cbtnaccion 
                        :isModal="true" 
                        :pEmitSeccion="ConfigModalContrato.EmitSeccion" 
                        :Id="item.IdContrato"
                        :IrA="ConfigModalContrato.Nombre">
                        </Cbtnaccion>
                    </td>
				</tr>
				<CSinRegistros :pContIF="ListContratos.length" :pColspan="11"></CSinRegistros>
			</template>
			<template v-if="Botones.Facturacion" slot="header">
				<tr>
					<th style="width:15%">Nombre del Contrato</th>
					<th>Servicio</th>
					<th>Folio</th>
					<th>Prefactura</th>
					<th>Facturado</th>
					<th>No° Prefactura</th>
					<th>Folio Fact. Real</th>
					<th>Monto</th>
					<th>Acciones</th>
				</tr>
			</template>
			<template v-if="Botones.Facturacion" slot="body">
				<tr v-for="(item,index) in ListFacturas" :key="index">
					<td>{{item.NumeroC}}</td>
					<td><i class="fa fa-calendar"></i> {{item.Fecha_I==null ? 'Sin Fecha' : $getCleanDate(item.Fecha_I,false)}}</td>
					<td>{{item.FolioServ==null ? 'Sin Folio' : item.FolioServ}}</td>
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.FechaReg,false)}}</td>
					<td><i class="fa fa-calendar"></i> {{item.FechaFacReal==null ? 'Sin Fecha' : $getCleanDate(item.FechaFacReal,false)}}</td>
					<td>{{item.FolioFactura}}</td>
					<td>{{item.FolioFactReal}}</td>
					<td>$ {{formateoMillon(parseFloat(item.Monto))}}</td>
					<td>
						<!-- <button @click="DescargarFactura(item.IdFactura)" class="btn-icon pl-01 mr-1" type="button" v-b-tooltip.hover title="Prefactura"><i class="fas fa-file-pdf fa-fw-m"></i></button> -->
                    	<button v-show="item.ArchivoFactura!=null && item.ArchivoFactura !=''" @click="DescargarPdfReal(item.ArchivoFactura)" class="btn-icon pl-01 mr-1" type="button" v-b-tooltip.hover title="Factura">
                    	    <i class="fas fa-file-pdf fa-fw-m"></i>
                    	</button>
                    	<!-- <button v-show="item.ArchivoCtaCobrar!=null && item.ArchivoCtaCobrar !=''" @click="DescargarReciboPago(item.ArchivoCtaCobrar)" class="btn-icon pl-01 mr-1" style="background-color:#ff640a !important;" type="button" v-b-tooltip.hover title="Recibo de Cobro">
                    	    <i class="fas fa-file-pdf fa-fw-m"></i>
                    	</button> -->
					</td>
					<!-- <td></td> -->
				</tr>
			</template>

			<template v-if="Botones.Compras" slot="Botonnuevo">
				<div class="row ml-2">
					<div class="col-lg-1" style="flex-basis:2% !important">
						<label for="">Proveedor</label>
					</div>
					<div class="col-lg-2 p-0 m-0">
						<treeselect
            			   	class="d-inline-block mt-0 pt-0 ml-2"
            			   	style="top: -4px;"
            			   	:maxHeight="180"
            			   	:options="ListaProveedores"
            			   	placeholder="Proveedor..."
            			   	v-model="IdProveedor"
            			   	@input="Lista()"
							:disable-fuzzy-matching="true"
            			/>
					</div>
					<div class="col-lg-9 d-flex justify-content-end">
						<h1 class="naranja text-center">${{formateoMillon(parseFloat(TotalCuentas))}}</h1>
					</div>
				</div>
			</template>

			<template v-if="Botones.Compras" slot="header">
				<tr>
					<th>Proveedor</th>
					<th>Factura</th>
					<th>Pago</th>
					<th>No° de Factura</th>
					<th>Concepto</th>
					<th class="text-center">Crédito</th>
					<th class="text-center">Pagado</th>
					<th>Estatus</th>
					<th>Monto</th>
					<th>Acciones</th>
				</tr>
			</template>
			<template v-if="Botones.Compras" slot="body">
				<tr v-for="(item,index) in ListCuentas" :key="index">
					<td v-b-tooltip.hover.top :title="item.Proveedor" style="width:20%">{{$limitCharacters(item.Proveedor,30)}}</td>
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.FechaFactura,false)}}</td>
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.FechaPago,false)}}</td>
					<td>{{item.NumFactura}}</td>
					<td>{{item.Concepto}}</td>
					<td class="text-center">{{item.Credito}}</td>
					<td class="text-center">{{item.Estatus}}</td>
					<td>{{item.Vigencia}}</td>
					<td>$ {{formateoMillon(parseFloat(item.Monto))}}</td>
					<td>
						<Cbtnaccion :isModal="true" :Id="item.IdCtaPagar" :IrA="'TipoUnidadForm'">
							<template slot="btnaccion" >

								<!-- <button v-if="item.Estatus === 'NO'" v-b-tooltip.hover.leftbottom title="Pagado" @click="Observation(item.IdCtaPagar)" data-toggle="modal" data-target="#Observacion" data-backdrop="static" data-keyboard="false" type="button" class="btn-icon mr-2">
									<i class="fas fa-dollar-sign"></i>
								</button> -->

								<button v-if="item.Estatus==='SI'" v-b-tooltip.hover.leftbottom title="Observación" @click="Observation(item.IdCtaPagar)" data-toggle="modal" data-target="#Observacion" data-backdrop="static" data-keyboard="false" type="button" class="btn-icon mr-2">
									<i class="fas fa-info-circle"></i>
								</button>

								<button v-if="item.Factura !== ''" @click="openInvoice(item)" v-b-tooltip.hover.top title="Factura" type="button" class="btn-icon mr-2">
									<i class="fas fa-file-pdf"></i>
								</button>
								<!-- <button v-if="item.Comprobante !== '' && item.Comprobante != null" @click="AbrirComprobante(item)" v-b-tooltip.hover.top title="Comprobante de Pago" type="button" class="btn-icon mr-2">
									<i class="fas fa-file-pdf"></i>
								</button> -->
							</template>
						</Cbtnaccion>
					</td>
					<!-- <td></td> -->
				</tr>
			</template>

			<template v-if="Botones.Estimaciones" slot="header">
				<tr>
					<th>N° Estimación</th>
					<th>Fecha</th>
					<th>Valor</th>
					<th>Crédito</th>
					<th>Realizó</th>
					<th>Aprueba</th>
					<th>Aprobación</th>
					<th>Facturación</th>
					<th>Descripción</th>
					<th>Observaciones</th>
					<th>Acciones</th>
					<th>
						<button @click="NuevoEstimacion()" type="button" data-toggle="modal" data-target="#Estimacion" class="btn-obs"><i class="fa fa-plus" title="Agregar Estimación"></i></button>
					</th>
				</tr>
			</template>
			<template v-if="Botones.Estimaciones" slot="body">
				<tr v-for="(item,index) in ListProyectoEstimaciones" :key="index">
					<td>{{item.NumEstimacion}}</td>
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.Fecha,false)}}</td>
					<td>$ {{formateoMillon(parseFloat(item.Valor))}}</td>
					<td>{{item.Credito}}</td>
					<td>{{item.Realizo}}</td>
					<td>{{item.Aprueba}}</td>
					<td><i class="fa fa-calendar"></i> {{item.FechaAprobacion}}</td>
					<td><i class="fa fa-calendar"></i> {{item.FechaFactura}}</td>
					<td>{{$limitCharacters(item.Descripcion,30)}}</td>
					<td>{{$limitCharacters(item.Observaciones,30)}}</td>
					<td>
						<Cbtnaccion 
                        :isModal="true" 
                        :pEmitSeccion="ConfigModalEstimacion.EmitSeccion" 
                        :Id="item.IdProyectoEstimacion"
                        :IrA="ConfigModalEstimacion.Nombre">
                        </Cbtnaccion>
					</td>
					<td></td>
				</tr>
			</template>
			
			<template v-if="Botones.Adicionales" slot="header">
				<tr>
					<th>Fecha de Venta</th>
					<th>Fecha de Termino</th>
					<th>Propuesta</th>
					<th>Tipo de Contrato</th>
					<th>Tipo de Servicio</th>
					<th>SubTipo de Servicio</th>
					<th>Valor Venta</th>
					<th>Cantidad de Pago</th>
					<th>Vendedor</th>
					<th>N° de Contrato</th>
					<th></th>
					<th>
						<button @click="NuevoAdicion()" type="button" data-toggle="modal" data-target="#Adicion" class="btn-obs"><i class="fa fa-plus" title="Agregar Adicion"></i></button>
					</th>
				</tr>
			</template>
			<template v-if="Botones.Adicionales" slot="body">
				<tr v-for="(item,index) in ListProyectoAdicionales" :key="index">
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.FechaVenta,false)}}</td>
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.FechaTermino,false)}}</td>
					<td>{{item.Propuesta}}</td>
					<td>{{item.TipoContrato}}</td>
					<td>{{item.TipoSer}}</td>
					<td>{{item.Concepto}}</td>
					<td>$ {{formateoMillon(parseFloat(item.ValorVenta))}}</td>
					<td>{{EvalNumPagos(item.NumPagos)}}</td>
					<td>{{item.Usuario}}</td>
					<td>{{item.NumeroC}}</td>
					<td>
						<Cbtnaccion 
                        :isModal="true" 
                        :pEmitSeccion="ConfigModalAdicion.EmitSeccion" 
                        :Id="item.IdProyectoAdicion"
                        :IrA="ConfigModalAdicion.Nombre">
                        </Cbtnaccion>
					</td>
					<td></td>
				</tr>
			</template>

			<template v-if="Botones.ReporteObra" slot="header">
				<tr>
					<th>Fecha</th>
					<th>Item</th>
					<th>Descripción</th>
					<th>Oportunidad</th>
					<th>Atraso</th>
					<th>Acción</th>
					<th>Avance</th>
					<th class="text-center">Estatus</th>
					<th>Acciones</th>
					<th>
						<button @click="NuevoReporteObra()" type="button" data-toggle="modal" data-target="#ReporteObra" class="btn-obs"><i class="fa fa-plus" title="Agregar Reporte de Obra"></i></button>
					</th>
				</tr>
			</template>
			<template v-if="Botones.ReporteObra" slot="body">
				<tr v-for="(item,index) in ListProyectoReporteObras" :key="index">
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.Fecha,false)}}</td>
					<td>{{item.Titulo!=null ? item.Titulo : EvalItemReporte(item.Item)}}</td>
					<td>{{$limitCharacters(item.Descripcion,45)}}</td>
					<td>{{item.Oportunidad}}</td>
					<td>{{EvalAtraso(item.Atraso)}}</td>
					<td>{{item.Accion}}</td>
					<td>{{item.Avance}} %</td>
					<td class="text-center">
						<div :class="EvalEstatusDia(item.EstatusDia)"></div>
					</td>
					<td>
						<Cbtnaccion
                        :isModal="true" 
                        :pEmitSeccion="ConfigModalReporteObra.EmitSeccion" 
                        :Id="item.IdProyectoReporteObra"
                        :IrA="ConfigModalReporteObra.Nombre"
						:pShowButtonEdit="item.Reciente==1"
						:pShowButtonDelete="item.Reciente==1">
							<template slot="btnaccion">
								<button v-show="item.ArchivoUno!=null && item.ArchivoUno !=''" @click="AbrirPdf(RutaReporteObra1+'/'+item.ArchivoUno)" class="btn-icon pl-01 mr-1" type="button" v-b-tooltip.hover title="Evidencia Uno">
                    	    		<i class="fas fa-file-pdf fa-fw-m"></i>
                    			</button>
								<button v-show="item.ArchivoDos!=null && item.ArchivoDos !=''" @click="AbrirPdf(RutaReporteObra2+'/'+item.ArchivoDos)" class="btn-icon pl-01 mr-1" type="button" v-b-tooltip.hover title="Evidencia Dos">
                    	    		<i class="fas fa-file-pdf fa-fw-m"></i>
                    			</button>
							</template>
						</Cbtnaccion>
					</td>
					<td></td>
				</tr>
			</template>
			
			<template v-if="Botones.Propuestas" slot="header">
				<th>Número</th>
				<th>Nombre Propuesta</th>
				<th>Tipo</th>
				<th>Valor</th>
				<th>Fecha</th>
				<th>Vigencia</th>
				<th class="text-center">Documentación</th>
				<th>Estatus</th>
				<th>Acciones</th>
			</template>

			<template v-if="Botones.Propuestas" slot="body">
				<tr v-for="(item,index) in ListProyectoPropuestas" :key="index">
					<td>{{item.Numero}}</td>
					<td>{{item.NombrePropuesta}}</td>
					<td>{{EvalConfigS(item.Tipo)}}</td>
					<td>$ {{formateoMillon(parseFloat(item.Valor))}}</td>
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.Fecha,false)}}</td>
					<td>{{item.Vigencia + ' días'}}</td>
					<td class="text-center">
						<button v-if="item.IdCotizacionServicio=='' || (item.ArchivoBruto!='' && item.ArchivoBruto!='Elegir Archivo(5MB)')" @click="AbrirPdf(item.Archivo)" class="btn-icon" title="Ver Documentación"><i class="fa fa-file-pdf"></i>
						</button>
						<button v-else @click="AbrirCotizacionCliente(item.IdCotizacionServicio)" class="btn-icon" title="Ver Documentación"><i class="fa fa-file-pdf"></i>
						</button>
					</td>
					<td>{{item.Estatus}}</td>
					<td>
						<Cbtnaccion 
                    		:isModal="true" 
                    		:pEmitSeccion="ConfigModalPropuesta.EmitSeccion" 
                    		:Id="item.IdPropuesta"
                    		:IrA="ConfigModalPropuesta.Nombre"
                    		:pShowBtnEdit="false"></Cbtnaccion>
					</td>
				</tr>
			</template>

			<template v-if="Botones.Personal" slot="header">
				<th>Nombre</th>
				<th>Profesion</th>
				<th>Posición</th>
				<th>Correo</th>
				<th>Teléfono</th>
				<th class="text-center">Horas Productivas</th>
				<th class="text-center">Check-In</th>
				<th>Acciones</th>
				<th>
					<button @click="NuevoPersonal()" type="button" data-toggle="modal" data-target="#Personal" class="btn-obs"><i class="fa fa-plus" title="Agregar Personal"></i></button>
				</th>
			</template>
			<template v-if="Botones.Personal" slot="body">
				<tr v-for="(item,index) in ListProyectoPersonal" :key="index">
					<td>
						<div class="d-flex align-items-center">
							<div v-if="item.Foto==null" :style="'width:50px;height:50px;border-radius:50%;background-image:url('+RutaFotoTrabajador+item.Foto2+');background-size:cover;background-repeat:no-repeat;background-position:center'">
                        	</div>
							<div v-else :style="'width:50px;height:50px;border-radius:50%;background-image:url('+RutaFotoProyectoPersonal+item.Foto+');background-size:cover;background-repeat:no-repeat;background-position:center'">
                        	</div>
							<span class="ml-2">{{item.Nombre}}</span>
						</div>
					</td>
					<!-- <td>{{item.Nombre}}</td> -->
					<td>{{item.Profesion}}</td>
					<td>{{item.Posicion}}</td>
					<td>{{item.Correo}}</td>
					<td>{{item.Telefono}}</td>
					<td class="text-center">{{item.HorasPS}}</td>
					<td v-if="!item.CheckIn.includes(['Sin Check In','No Laboral'])">
						<div class="d-flex justify-content-center">
                            <div v-b-tooltip.hover :title="item.CheckIn" :class="DefinirClaseCheck(item.CheckIn) +' m-0'"></div>
                        </div>
					</td>
					<td v-else class="text-center">{{item.CheckIn}}</td>
					<td>
						<Cbtnaccion 
                    		:isModal="true" 
                    		:pEmitSeccion="ConfigModalPersonal.EmitSeccion" 
                    		:Id="item.IdProyectoPersonal"
                    		:IrA="ConfigModalPersonal.Nombre"></Cbtnaccion>
					</td>
					<td></td>
				</tr>
			</template>

			<template v-if="Botones.Documentos" slot="Filtros">
				<!-- <div class="row ml-2">
					<div class="col-lg-12"> -->
						<div class="form-inline">
							<label for="" class="mr-3">Tipo</label>
							<select @change="Lista" v-model="Filtro.Tipo" class="form-control">
								<option value="">-Tipo-</option>
								<option value="1">Personal</option>
								<option value="2">Contratista</option>
								<option value="3">RFI</option>
								<option value="4">Seguridad</option>
							</select>
						</div>
					<!-- </div>
				</div> -->
			</template>
			<template v-if="Botones.Documentos" slot="header">
				<th>Nombre</th>
				<th>Tipo</th>
				<th>Expedición</th>
				<!-- <th>Dirigido A</th> -->
				<th>Comentarios</th>
				<th>Acciones</th>
				<th>
					<button @click="NuevoDocumento()" type="button" data-toggle="modal" data-target="#Documento" class="btn-obs"><i class="fa fa-plus" title="Agregar Documento"></i></button>
				</th>
			</template>

			<template v-if="Botones.Documentos" slot="body">
				<tr v-for="(item,index) in ListProyectoDocumentos" :key="index">
					<td>{{item.Nombre}}</td>
					<td>{{EvalTipoDocumento(item.Tipo)}}</td>
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.Fecha,false)}}</td>
					<!-- <td>{{item.DirigidoA}}</td> -->
					<td>{{$limitCharacters(item.Comentarios,50)}}</td>
					<td>
						<Cbtnaccion 
                    		:isModal="true" 
                    		:pEmitSeccion="ConfigModalDocumento.EmitSeccion" 
                    		:Id="item.IdProyectoDocumento"
                    		:IrA="ConfigModalDocumento.Nombre">
							<template slot="btnaccion">
								<button @click="AbrirPdf(RutaProyectoDocumento+'/'+item.Archivo)" class="btn-icon pl-01 mr-2" type="button" v-b-tooltip.hover title="Documento">
                    	    		<i class="fas fa-file-pdf fa-fw-m"></i>
                    			</button>
							</template>
						</Cbtnaccion>
					</td>
					<td></td>
				</tr>
			</template>

			<template v-if="Botones.Planos" slot="Filtros">
				<!-- <div class="row ml-2">
					<div class="col-lg-12"> -->
						<div class="form-inline">
							<label for="" class="mr-3">Tipo</label>
							<select @change="Lista" v-model="Filtro.Tipo" class="form-control">
								<option value="">-Tipo-</option>
								<option value="1">Site Plan</option>
								<option value="2">Floor Plan</option>
								<option value="3">Elevation Drawing</option>
								<option value="4">Section Drawing</option>
								<option value="5">Detail Drawing</option>
								<option value="6">Structural Drawing</option>
								<option value="7">MEP Drawings</option>
								<option value="8">Finishing Drawings</option>
								<option value="9">Shop Drawings</option>
								<option value="10">As-Built Drawings</option>
							</select>
						</div>
					<!-- </div>
				</div> -->
			</template>
			<template v-if="Botones.Planos" slot="header">
				<th>Nombre</th>
				<th>Tipo de Plano</th>
				<th>Fecha</th>
				<th>Revisión</th>
				<th>Dibujó</th>
				<th>Diseñó</th>
				<th>Comentarios</th>
				<th>Acciones</th>
				<th>
					<button @click="NuevoPlano()" type="button" data-toggle="modal" data-target="#Plano" class="btn-obs"><i class="fa fa-plus" title="Agregar Plano"></i></button>
				</th>
			</template>

			<template v-if="Botones.Planos" slot="body">
				<tr v-for="(item,index) in ListProyectoPlanos" :key="index">
					<td>{{item.Nombre}}</td>
					<td>{{GetTipoPlano(item.Tipo)}}</td>
					<td><i class="fa fa-calendar"></i> {{$getCleanDate(item.Fecha,false)}}</td>
					<td>{{item.Revision}}</td>
					<td>{{item.Dibujo}}</td>
					<td>{{item.Diseno}}</td>
					<td>{{$limitCharacters(item.Comentario,50)}}</td>
					<td>
						<Cbtnaccion 
                    		:isModal="true" 
                    		:pEmitSeccion="ConfigModalPlano.EmitSeccion" 
                    		:Id="item.IdProyectoPlano"
                    		:IrA="ConfigModalPlano.Nombre">
							<template slot="btnaccion">
								<button @click="AbrirPdf(RutaProyectoPlano+'/'+item.Archivo)" class="btn-icon pl-01 mr-2" type="button" v-b-tooltip.hover title="Documento">
                    	    		<i class="fas fa-file-pdf fa-fw-m"></i>
                    			</button>
							</template>
						</Cbtnaccion>
					</td>
					<td></td>
				</tr>
			</template>

			<template v-if="Botones.Garantias" slot="header">
				<th>Servicio</th>
				<th>Fecha</th>
				<th>Tipo de Servicio</th>
				<th>Lider Servicio</th>
				<th>Tareas</th>
				<th>Acciones</th>
			</template>

			<template v-if="Botones.Garantias" slot="body">
				<tr v-for="(item,index) in ListGarantias" :key="index">
					<td>{{ item.Folio }}</td>
                	<td><i class="fa fa-calendar"></i> {{ $getCleanDate(item.Fecha_I, false) }}</td>
                	<td>{{ item.Servicio }}</td>
                	<td>{{ item.Nombre == null ? 'No Asignado' : item.Nombre }}</td>
                	<td>{{ $limitCharacters(item.Observaciones,30) }}</td>
					<td>
                    	<button
							v-b-tooltip.hover.left
							@click="DescargarReporte(item.IdServicio)"
							type="button"
							data-backdrop="static"
							data-keyboard="false"
							class="btn-icon mr-2"
							title="Ver Reporte de Servicio"
						>
							<i 
							:id="'pdfOrden_'+item.IdServicio"
							class="fas fa-file-pdf fa-fw-m"></i>
						</button>

                    	<button
							v-b-tooltip.hover.left
							@click="DescargarEvidencia(item.IdServicio)"
							type="button"
							data-backdrop="static"
							data-keyboard="false"
							class="btn-icon mr-2"
							title="Ver Reporte Fotográfico"
						>
							<i 
							:id="'pdfOrden_'+item.IdServicio"
							class="fas fa-file-pdf fa-fw-m"></i>
						</button>
					</td>
				</tr>
			</template>

			<template v-if="Botones.Servicios" slot="header">
				<th>Servicio</th>
				<th>Fecha</th>
				<th>Tipo de Servicio</th>
				<th>Lider Servicio</th>
				<th>Tareas</th>
				<th>Acciones</th>
			</template>

			<template v-if="Botones.Servicios" slot="body">
				<tr v-for="(item,index) in ListGarantias" :key="index">
					<td>{{ item.Folio }}</td>
                	<td><i class="fa fa-calendar"></i> {{ $getCleanDate(item.Fecha_I, false) }}</td>
                	<td>{{ item.Servicio }}</td>
                	<td>{{ item.Nombre == null ? 'No Asignado' : item.Nombre }}</td>
                	<td>{{ $limitCharacters(item.Observaciones,30) }}</td>
					<td>
                    	<button
							v-b-tooltip.hover.left
							@click="DescargarReporte(item.IdServicio)"
							type="button"
							data-backdrop="static"
							data-keyboard="false"
							class="btn-icon mr-2"
							title="Ver Reporte de Servicio"
						>
							<i 
							:id="'pdfOrden_'+item.IdServicio"
							class="fas fa-file-pdf fa-fw-m"></i>
						</button>

                    	<button
							v-b-tooltip.hover.left
							@click="DescargarEvidencia(item.IdServicio)"
							type="button"
							data-backdrop="static"
							data-keyboard="false"
							class="btn-icon mr-2"
							title="Ver Reporte Fotográfico"
						>
							<i 
							:id="'pdfOrden_'+item.IdServicio"
							class="fas fa-file-pdf fa-fw-m"></i>
						</button>
					</td>
				</tr>
			</template>

			<template v-if="Botones.Materiales" slot="Botonnuevo">
				<div class="col-lg-12">
					<div class="row mr-0 ml-0">
						<div class="col-lg-4">
							<div class="form-inline">
								<input type="text" class="form-control mr-2 lup" v-model="Filtro.Nombre" placeholder="Código Empresa / Item / Descripción..." @input="Filtrar">
								<label for="">Estatus</label>
								<select @change="Lista" v-model="Filtro.Estatus" class="form-control ml-2">
									<option value="">-Estatus-</option>
									<option value="1">Comprado</option>
									<option value="2">Proceso Compra</option>
									<option value="3">Pendiente</option>
									<option value="4">No Disponible</option>
									<option value="5">Cancelado</option>
								</select>
							</div>
						</div>
						<div class="col-lg-8 d-flex justify-content-end">
							<button :disabled="DisableBtnExportMaterial" type="button" @click="ExportarExcelMaterial" class="btn btn-01 mr-2 mt-1" style="height:80%">
								<i v-show="DisableBtnExportMaterial" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
								<i v-show="!DisableBtnExportMaterial" class="fa fa-file-excel"></i> Generar Excel
							</button>
							<input style="display:none" id="ArchivoHoja" @change="SubirArchivoMaterial" type="file" ref="excelmaterial">
							<label for="ArchivoHoja" class="btn btn-primary mr-2 mt-1"><i class="fa fa-file-excel"></i> <span class="ml-1">Importar Excel</span></label>
							<span class="mr-4 mt-2">{{ArchivoMaterial}}</span>
							<button :disabled="DisableBtnImportMaterial || ArchivoMaterial == ''" type="button" @click="ImportarExcelMaterial" class="btn btn-pink mt-1 mr-5" style="height:80%">
								<i v-show="DisableBtnImportMaterial" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
								<i v-show="!DisableBtnImportMaterial" class="fa fa-file-upload"></i> Subir Archivo
							</button>
							<button data-toggle="modal" data-target="#MaterialAdd" type="button" class="btn btn-primary ml-2 mt-1" style="height:80%"><i class="fa fa-plus-circle"></i> Inventario</button>
						</div>
					</div>
				</div>
			</template>
			<template v-if="Botones.Materiales" slot="header">
				<th>Ítem</th>
				<th>Marca</th>
				<th>Modelo</th>
				<th>Descripción</th>
				<th>Unidad</th>
				<th class="text-center">Cantidad</th>
				<th class="text-center">Presupuesto</th>
				<th>Requerimiento</th>
				<th class="text-center">Comprometido</th>
				<th>Compra</th>
				<th class="text-center">Adquirido</th>
				<th>Factura</th>
				<th>Estatus</th>
				<th>Acciones</th>
			</template>
			<template v-if="Botones.Materiales" slot="body">
				<tr v-for="(item,index) in Materiales" :key="index">
					<td>{{item.Item}}</td>
					<td>{{item.Marca}}</td>
					<td>{{item.Modelo}}</td>
					<td>{{item.Descripcion}}</td>
					<td>{{item.Unidad}}</td>
					<td class="text-center">{{item.Cantidad}}</td>
					<td class="text-center">$ {{Number(item.Presupuesto).toLocaleString('es-MX')}}</td>
					<td><i class="fa fa-calendar"></i> {{item.Requerido==null ? 'S/F' : $getCleanDate(item.Requerido,false)}}</td>
					<td class="text-center">$ {{Number(item.Comprometido).toLocaleString('es-MX')}}</td>
					<td><i class="fa fa-calendar"></i> {{item.Compra==null ? 'S/F' : $getCleanDate(item.Compra,false)}}</td>
					<td class="text-center">$ {{Number(item.Adquirido).toLocaleString('es-MX')}}</td>
					<td>{{item.Factura}}</td>
					<td>
						<div v-b-tooltip.hover.top :title="EvalEstatusAlmacenNombre(item.Estatus)" :class="EvalEstatusAlmacen(item.Estatus)"></div>
					</td>
					<td>
						<button 
							@click="EditarMaterial(item.IdProyectoMaterial)" 
							v-b-tooltip.hover.top :title="'Editar'" 
							type="button"
							data-toggle="modal" data-target="#MaterialForm"
							class="btn-icon"><i class="fa fa-pencil"></i>
						</button>

						<button 
							@click="EliminarMaterial(item.IdProyectoMaterial)" 
							v-b-tooltip.hover.top :title="'Eliminar'" 
							type="button"
							class="btn-icon-02 ml-2"><i class="fa fa-trash"></i>
						</button>
					</td>
				</tr>
			</template>

			<template v-if="Botones.Equipos" slot="Botonnuevo">
				<div class="col-lg-12">
					<div class="row mr-0 ml-0">
						<div class="col-lg-4">
							<div class="form-inline">
								<input type="text" class="form-control mr-2 lup" v-model="Filtro.Nombre" placeholder="Código Empresa / Item / Descripción..." @input="Filtrar">
								<label for="">Estatus</label>
								<select @change="Lista" v-model="Filtro.Estatus" class="form-control ml-2">
									<option value="">-Estatus-</option>
									<option value="1">Comprado</option>
									<option value="2">Proceso Compra</option>
									<option value="3">Pendiente</option>
									<option value="4">No Disponible</option>
									<option value="5">Cancelado</option>
								</select>
							</div>
						</div>
						<div class="col-lg-8 d-flex justify-content-end">
							<button :disabled="DisableBtnExportEquipo" type="button" @click="ExportarExcelEquipo" class="btn btn-01 mr-2 mt-1" style="height:80%">
								<i v-show="DisableBtnExportEquipo" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
								<i v-show="!DisableBtnExportEquipo" class="fa fa-file-excel"></i> Generar Excel
							</button>
							<input style="display:none" id="ArchivoHoja" @change="SubirArchivoEquipo" type="file" ref="excelequipo">
							<label for="ArchivoHoja" class="btn btn-primary mr-2 mt-1"><i class="fa fa-file-excel"></i> <span class="ml-1">Importar Excel</span></label>
							<span class="mr-4 mt-2">{{ArchivoEquipo}}</span>
							<button :disabled="DisableBtnImportEquipo || ArchivoEquipo == ''" type="button" @click="ImportarExcelEquipo" class="btn btn-pink mt-1 mr-5" style="height:80%">
								<i v-show="DisableBtnImportEquipo" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
								<i v-show="!DisableBtnImportEquipo" class="fa fa-file-upload"></i> Subir Archivo
							</button>
							<button data-toggle="modal" data-target="#EquipoAdd" type="button" class="btn btn-primary ml-2 mt-1" style="height:80%"><i class="fa fa-plus-circle"></i> Inventario</button>
						</div>
					</div>
				</div>
			</template>
			<template v-if="Botones.Equipos" slot="header">
				<th>Ítem</th>
				<th>Marca</th>
				<th>Modelo</th>
				<th>Descripción</th>
				<th>Unidad</th>
				<th class="text-center">Cantidad</th>
				<th class="text-center">Presupuesto</th>
				<th>Requerimiento</th>
				<th class="text-center">Comprometido</th>
				<th>Compra</th>
				<th class="text-center">Adquirido</th>
				<th>Factura</th>
				<th>Estatus</th>
				<th>Acciones</th>
			</template>
			<template v-if="Botones.Equipos" slot="body">
				<tr v-for="(item,index) in Equipos" :key="index">
					<td>{{item.Item}}</td>
					<td>{{item.Marca}}</td>
					<td>{{item.Modelo}}</td>
					<td>{{item.Descripcion}}</td>
					<td>{{item.Unidad}}</td>
					<td class="text-center">{{item.Cantidad}}</td>
					<td class="text-center">$ {{Number(item.Presupuesto).toLocaleString('es-MX')}}</td>
					<td><i class="fa fa-calendar"></i> {{item.Requerido==null ? 'S/F' : $getCleanDate(item.Requerido,false)}}</td>
					<td class="text-center">$ {{Number(item.Comprometido).toLocaleString('es-MX')}}</td>
					<td><i class="fa fa-calendar"></i> {{item.Compra==null ? 'S/F' : $getCleanDate(item.Compra,false)}}</td>
					<td class="text-center">$ {{Number(item.Adquirido).toLocaleString('es-MX')}}</td>
					<td>{{item.Factura}}</td>
					<td>
						<div v-b-tooltip.hover.top :title="EvalEstatusAlmacenNombre(item.Estatus)" :class="EvalEstatusAlmacen(item.Estatus)"></div>
					</td>
					<td>
						<button 
							@click="EditarEquipo(item.IdProyectoEquipo)" 
							v-b-tooltip.hover.top :title="'Editar'" 
							type="button"
							data-toggle="modal" data-target="#EquipoForm"
							class="btn-icon"><i class="fa fa-pencil"></i>
						</button>

						<button 
							@click="EliminarEquipo(item.IdProyectoEquipo)" 
							v-b-tooltip.hover.top :title="'Eliminar'" 
							type="button"
							class="btn-icon-02 ml-2"><i class="fa fa-trash"></i>
						</button>
					</td>
				</tr>
			</template>
		</Clist>
		<Modal :Showbutton="false" :pEmitSeccion="ConfigModalContrato.EmitSeccion" :NameModal="ConfigModalContrato.NombreSeccion"  :size="ConfigModalContrato.Size" :Nombre="'Contratos'" :poBtnSave="oBtnSaveContrato">
            <template slot="Form">
                <Contrato :NameList="ConfigModalContrato.NameForm" :pIdClienteS="Proyecto.IdClienteS" :pIdCliente="Proyecto.IdCliente" :poBtnSave="oBtnSaveContrato">
                </Contrato>
            </template>
        </Modal>
		<Modal :poBtnSave="oBtnSaveCuenta" :size="'modal-lg'" :Nombre="'Operaciones Cuentas Por Pagar'">
			<template slot="Form">
				<Cuenta :poBtnSave="oBtnSaveCuenta"></Cuenta>
			</template>
		</Modal>
		<Modal
			:NameModal="'Observacion'"
			:poBtnSave="oBtnSave2"
			:size="'modal-lg'"
			:Nombre="'Observación'"
		>
			<template slot="Form">
				<Observacion :poBtnSave="oBtnSave2"></Observacion>
			</template>
		</Modal>
		<Modal :pEmitSeccion="ConfigModalEstimacion.EmitSeccion" :NameModal="ConfigModalEstimacion.NombreSeccion"  :size="ConfigModalEstimacion.Size" :Nombre="'Estimaciones'" :poBtnSave="oBtnSaveEstimacion">
            <template slot="Form">
                <Estimacion :NameList="ConfigModalEstimacion.NameForm" :poBtnSave="oBtnSaveEstimacion">
                </Estimacion>
            </template>
        </Modal>
		<Modal :pEmitSeccion="ConfigModalAdicion.EmitSeccion" :NameModal="ConfigModalAdicion.NombreSeccion"  :size="ConfigModalAdicion.Size" :Nombre="'Adicionales'" :poBtnSave="oBtnSaveAdicion">
            <template slot="Form">
                <Adicion :NameList="ConfigModalAdicion.NameForm" :poBtnSave="oBtnSaveAdicion" :pIdContratoMaster="Proyecto.IdContrato" :pIdCliente="Proyecto.IdCliente" :pIdClienteS="Proyecto.IdClienteS">
                </Adicion>
            </template>
        </Modal>
		<Modal :pEmitSeccion="ConfigModalReporteObra.EmitSeccion" :NameModal="ConfigModalReporteObra.NombreSeccion"  :size="ConfigModalReporteObra.Size" :Nombre="'Reporte de Obra'" :poBtnSave="oBtnSaveReporteObra">
            <template slot="Form">
                <ReporteObra :NameList="ConfigModalReporteObra.NameForm" :poBtnSave="oBtnSaveReporteObra" :pListProyectoReporteObra="ListProyectoReporteObrasCompleto">
                </ReporteObra>
            </template>
        </Modal>
		<Modal :pEmitSeccion="ConfigModalPlano.EmitSeccion" :NameModal="ConfigModalPlano.NombreSeccion"  :size="ConfigModalPlano.Size" :Nombre="'Plano'" :poBtnSave="oBtnSavePlano">
            <template slot="Form">
                <Plano :NameList="ConfigModalPlano.NameForm" :poBtnSave="oBtnSavePlano">
                </Plano>
            </template>
        </Modal>
		<Modal :pEmitSeccion="ConfigModalPersonal.EmitSeccion" :NameModal="ConfigModalPersonal.NombreSeccion"  :size="ConfigModalPersonal.Size" :Nombre="'Personal'" :poBtnSave="oBtnSavePersonal">
            <template slot="Form">
                <Personal :NameList="ConfigModalPersonal.NameForm" :poBtnSave="oBtnSavePersonal">
                </Personal>
            </template>
        </Modal>
		<Modal :pEmitSeccion="ConfigModalDocumento.EmitSeccion" :NameModal="ConfigModalDocumento.NombreSeccion"  :size="ConfigModalDocumento.Size" :Nombre="'Documentación'" :poBtnSave="oBtnSaveDocumento">
            <template slot="Form">
                <Documento :NameList="ConfigModalDocumento.NameForm" :poBtnSave="oBtnSaveDocumento">
                </Documento>
            </template>
        </Modal>
		<Modal :pEmitSeccion="ConfigModalMaterialAdd.EmitSeccion" :NameModal="ConfigModalMaterialAdd.NombreSeccion"  :size="ConfigModalMaterialAdd.Size" :Nombre="'Agregar Material'" :poBtnSave="oBtnSaveMaterialAdd">
            <template slot="Form">
                <Cmateriales :pTipo="3" :NameList="ConfigModalMaterialAdd.NameForm" :poBtnSave="oBtnSaveMaterialAdd">
                </Cmateriales>
            </template>
        </Modal>
		<Modal :pEmitSeccion="ConfigModalMaterialForm.EmitSeccion" :NameModal="ConfigModalMaterialForm.NombreSeccion"  :size="ConfigModalMaterialForm.Size" :Nombre="'Material'" :poBtnSave="oBtnSaveMaterialForm">
            <template slot="Form">
                <MaterialForm :NameList="ConfigModalMaterialForm.NameForm" :poBtnSave="oBtnSaveMaterialForm">
                </MaterialForm>
            </template>
        </Modal>
		<Modal :pEmitSeccion="ConfigModalEquipoAdd.EmitSeccion" :NameModal="ConfigModalEquipoAdd.NombreSeccion"  :size="ConfigModalEquipoAdd.Size" :Nombre="'Agregar Equipo'" :poBtnSave="oBtnSaveEquipoAdd">
            <template slot="Form">
                <Cequipos :pTipo="3" :NameList="ConfigModalEquipoAdd.NameForm" :poBtnSave="oBtnSaveEquipoAdd">
                </Cequipos>
            </template>
        </Modal>
		<Modal :pEmitSeccion="ConfigModalEquipoForm.EmitSeccion" :NameModal="ConfigModalEquipoForm.NombreSeccion"  :size="ConfigModalEquipoForm.Size" :Nombre="'Material'" :poBtnSave="oBtnSaveEquipoForm">
            <template slot="Form">
                <EquipoForm :NameList="ConfigModalEquipoForm.NameForm" :poBtnSave="oBtnSaveEquipoForm">
                </EquipoForm>
            </template>
        </Modal>
		<Modal :Showbutton="false" :NameModal="'imagen'" :size="'modal-lg'" :Nombre="'Imagen'">
			<template slot="Form">
				<div class="form-row justify-content-center align-items-center">
					<img :src="ImagenAMostrar" alt="Aún no hay una imagen para mostrar" class="img-thumbnail">
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
import Modal from "../../../components/Cmodal";
import Clist from "@/components/Clist.vue";
import Cbtnaccion from "@/components/Cbtnaccion.vue";
import CSinRegistros from "@/components/CSinRegistros";
import Contrato from "@/views/catalogos/contratos/Form.vue";
import Estimacion from "./forms/Estimacion.vue";
import Adicion from "./forms/Adicion.vue";
import ReporteObra from "./forms/ReporteObra.vue";
import Personal from "./forms/Personal.vue";
import Documento from "./forms/Documento.vue";
import Plano from "./forms/Plano.vue";
import Cuenta from "@/views/modulos/ctaporcobrarpagar/ctaporpagaropera/Form.vue";
import Observacion from "@/views/modulos/ctaporcobrarpagar/ctaporpagaropera/Observacion.vue";
import Cmateriales from '@/views/modulos/almacen/materiales/List.vue';
import Cequipos from '@/views/modulos/almacen/equipos/List.vue';
import MaterialForm from '@/views/modulos/proyecto/forms/Material.vue';
import EquipoForm from '@/views/modulos/proyecto/forms/Equipo.vue';
import Config from "@/helpers/VarConfig.js";
export default {
	name: "ProyectoDesglose",
	props:["IdProyecto","IdContratoMaster"],
	components:{
		Modal,Clist,Cbtnaccion,CSinRegistros,
		Contrato,Cuenta,Observacion,Estimacion,Adicion,ReporteObra,Personal,Documento,Plano,
		Cmateriales,Cequipos,MaterialForm,EquipoForm
	},
	data() {
		return {
			ShowBusqueda:false,
			ValidElement:Config.validImage2m,
			regresar:true,
			Titulo:"Project Management",
			EsModal:true,
			SeriesProgreso:[0],
			SeriesPresupuesto:[50],
			ConfigLoad:{
				ShowLoader:false,
				ClassLoad:true
			},
			Filtro: {
				Nombre: "",
				Placeholder: "Nombre..",
				TotalItem: 0,
				Pagina: 1,
				Entrada: 16,
				Show:false,
				Tipo:'',
				Estatus:''
			},
			ListaProveedores:[],
			IdProveedor:null,
			ShowFiltro:false,
			ProgresoGraph:{
				chart: {
            	  height: 350,
            	  type: 'radialBar',
				  offsetY:-50
            	},
				plotOptions: {
            	  radialBar: {
            	    hollow: {
						margin:0,
            	      	size: '40%',
            	    },
					track:{
						background:'#B1E6FC'
					},
					dataLabels:{
						name: {
                  		  fontSize: '25px',
                  		  color: '#000',
                  		  offsetY: 120,
						  fontWeight:600
                  		},
						value:{
							offsetY: -7,
							fontSize: '28px',
							color:'#1B17BB',
							fontWeight:600
						}
					}
            	  },
            	},
				fill:{
					type:'gradient',
					gradient:{
						shade: 'dark',
                  		shadeIntensity: 0.15,
                  		inverseColors: false,
                  		opacityFrom: 1,
                  		opacityTo: 1,
                  		stops: [0, 50, 65, 91],
						colorStops:[
							{
								offset: 0,
      							color: '#038ED9',
      							opacity: 1
							},
							{
    						  	offset: 100,
    						  	color: '#1B17BB',
    						  	opacity: 1
    						}
						]
					}
				},
            	labels: ['Progreso'],
			},
			PresupuestoGraph:{
				chart: {
            	  height: 350,
            	  type: 'radialBar',
				  offsetY:-50
            	},
				plotOptions: {
            	  radialBar: {
            	    hollow: {
						margin:0,
            	      	size: '40%',
            	    },
					track:{
						background:'#B1E6FC'
					},
					dataLabels:{
						name: {
                  		  fontSize: '25px',
                  		  color: '#000',
                  		  offsetY: 120,
						  fontWeight:600
                  		},
						value:{
							offsetY: -7,
							fontSize: '28px',
							color:'#1B17BB',
							fontWeight:600
						}
					}
            	  },
            	},
				fill:{
					type:'gradient',
					gradient:{
						shade: 'dark',
                  		shadeIntensity: 0.15,
                  		inverseColors: false,
                  		opacityFrom: 1,
                  		opacityTo: 1,
                  		stops: [0, 50, 65, 91],
						colorStops:[
							{
								offset: 0,
      							color: '#038ED9',
      							opacity: 1
							},
							{
    						  	offset: 100,
    						  	color: '#1B17BB',
    						  	opacity: 1
    						}
						]
					}
				},
            	labels: ['Presupuesto'],
			},
			Proyecto:{
                IdProyecto:0,
                IdEmpresa:"",
                IdSucursal:"",
                IdCliente:null,
                IdClienteS:null,
				IdContrato:null,
				Cliente:'',
				Propiedad:'',
				Contrato:'',
				ContratosAditiva:[],
                Nombre:"",
                Valor:"",
                Direccion:"",
				Ciudad:"",
				ProjectManager:"",
				Residente:"",
				Estatus:"",
                Latitud:"", 
                Longitud:"",
                FechaInicio:"",
                FechaFin:"",
                Imagen:"",
				ImagenExtra:"",
				InicioContrato:"",
				TerminoContrato:""
            },
			UtilidadActual:0,
			ValoresCard:{
				Venta:0,
				VentaPorcen:0,
				CostoOperativo:0,
				CostoOperativoPorcen:0,
				Facturado:0,
				FacturadoPorcen:0,
				Estimado:0,
				EstimadoPorcen:0,
				GastoOp:0,
				GastoOpPorcen:0,
				Retencion:0,
				RetencionPorcen:0
			},
			ContadorImagenProyecto:0,
			BndImagen:0,
			ObjImagen:{},
			ContadorImagenExtra:0,
			BndImagenExtra:0,
			ObjImagenExtra:{},
			ImagenAMostrar:"",
			RutaImagen:"",
			RutaImagenExtra:"",
			Botones:{
				Contratos:false,
				Facturacion:true,
				Compras:false,
				Estimaciones:false,
				Adicionales:false,
				RFI:false,
				ReporteObra:false,
				Propuestas:false,
				Personal:false,
				Garantias:false,
				Documentos:false,
				Servicios:false,
				Planos:false,
				Materiales:false,
				Equipos:false
			},
			ListContratos:[],
			ListFacturas:[],
			ListCuentas:[],
			ListProyectoEstimaciones:[],
			ListProyectoAdicionales:[],
			ListProyectoReporteObras:[],
			ListProyectoReporteObrasCompleto:[],
			ListProyectoPropuestas:[],
			ListProyectoPersonal:[],
			ListProyectoDocumentos:[],
			ListGarantias:[],
			ListProyectoPlanos:[],
			ConfigModalContrato:{
                NombreSeccion:"Contratos",
                EmitSeccion:"Contratos",
                Size:"modal-xl",
                Nombre:"Contratos",
                NameForm:"Contratos"
            },
			oBtnSaveContrato:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Contratos",
                EmitSeccion:"Contratos"
            },
			ConfigModalFactura:{
                NombreSeccion:"Factura",
                EmitSeccion:"Factura",
                Size:"modal-md",
                Nombre:"Factura",
                NameForm:"Factura"
            },
			oBtnSaveFactura:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Factura",
                EmitSeccion:"Factura"
            },
			ConfigModalCuenta:{

			},
			oBtnSaveCuenta:{
				isModal: true,
				disableBtn: false,
				toast: 0
			},
			oBtnSave2: {
				isModal: true,
				disableBtn: false,
				toast: 0,
				nombreModal: "Observacion"
			},
			ConfigModalEstimacion:{
                NombreSeccion:"Estimacion",
                EmitSeccion:"Estimacion",
                Size:"modal-lg",
                Nombre:"Estimacion",
                NameForm:"Estimacion"
            },
			oBtnSaveEstimacion:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Estimacion",
                EmitSeccion:"Estimacion"
            },
			ConfigModalAdicion:{
                NombreSeccion:"Adicion",
                EmitSeccion:"Adicion",
                Size:"modal-xl",
                Nombre:"Adicion",
                NameForm:"Adicion"
            },
			oBtnSaveAdicion:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Adicion",
                EmitSeccion:"Adicion"
            },
			ConfigModalReporteObra:{
                NombreSeccion:"ReporteObra",
                EmitSeccion:"ReporteObra",
                Size:"modal-lg",
                Nombre:"ReporteObra",
                NameForm:"ReporteObra"
            },
			oBtnSaveReporteObra:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"ReporteObra",
                EmitSeccion:"ReporteObra"
            },
			ConfigModalPropuesta:{
                NombreSeccion:"Propuesta",
                EmitSeccion:"Propuesta",
                Size:"modal-lg",
                Nombre:"Propuesta",
                NameForm:"Propuesta"
            },
			oBtnSavePropuesta:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Propuesta",
                EmitSeccion:"Propuesta"
            },
			ConfigModalPersonal:{
                NombreSeccion:"Personal",
                EmitSeccion:"Personal",
                Size:"modal-lg",
                Nombre:"Personal",
                NameForm:"Personal"
            },
			oBtnSavePersonal:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Personal",
                EmitSeccion:"Personal"
            },
			ConfigModalDocumento:{
                NombreSeccion:"Documento",
                EmitSeccion:"Documento",
                Size:"modal-md",
                Nombre:"Documento",
                NameForm:"Documento"
            },
			oBtnSaveDocumento:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Documento",
                EmitSeccion:"Documento"
            },
			ConfigModalPlano:{
                NombreSeccion:"Plano",
                EmitSeccion:"Plano",
                Size:"modal-lg",
                Nombre:"Plano",
                NameForm:"Plano"
            },
			oBtnSavePlano:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Plano",
                EmitSeccion:"Plano"
            },
			ConfigModalMaterialAdd:{
                NombreSeccion:"MaterialAdd",
                EmitSeccion:"MaterialAdd",
                Size:"modal-xxl",
                Nombre:"MaterialAdd",
                NameForm:"MaterialAdd"
            },
			oBtnSaveMaterialAdd:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"MaterialAdd",
                EmitSeccion:"MaterialAdd"
            },
			ConfigModalMaterialForm:{
                NombreSeccion:"MaterialForm",
                EmitSeccion:"MaterialForm",
                Size:"modal-xl",
                Nombre:"MaterialForm",
                NameForm:"MaterialForm"
            },
			oBtnSaveMaterialForm:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"MaterialForm",
                EmitSeccion:"MaterialForm"
            },
			ConfigModalEquipoAdd:{
                NombreSeccion:"EquipoAdd",
                EmitSeccion:"EquipoAdd",
                Size:"modal-xxl",
                Nombre:"EquipoAdd",
                NameForm:"EquipoAdd"
            },
			oBtnSaveEquipoAdd:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"EquipoAdd",
                EmitSeccion:"EquipoAdd"
            },
			ConfigModalEquipoForm:{
                NombreSeccion:"EquipoForm",
                EmitSeccion:"EquipoForm",
                Size:"modal-xl",
                Nombre:"EquipoForm",
                NameForm:"EquipoForm"
            },
			oBtnSaveEquipoForm:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"EquipoForm",
                EmitSeccion:"EquipoForm"
            },
			ShowGraficaProgreso:false,
			ShowGraficaPresupuesto:true,
			ShowPager:true,
			RutaFileFactura:'',
			RutaFileCtaCobrar:'',
			RutaReporteObra1:'',
			RutaReporteObra2:'',
			RutaPdfContrato:'',
			RutaFotoProyectoPersonal:'',
			RutaFotoTrabajador:'',
			RutaProyectoDocumento:'',
			RutaProyectoPlano:'',
			TotalCuentas:0,
			DisableBtnExportMaterial:false,
			DisableBtnImportMaterial:false,
			ArchivoMaterial:'',
			Materiales:[],
			MaterialesTodos:[],
			TimeOut:null,
			DisableBtnExportEquipo:false,
			DisableBtnImportEquipo:false,
			ArchivoEquipo:'',
			Equipos:[],
			Venta:{}
		}
	},
	methods: {
		Filtrar(){
			clearTimeout(this.TimeOut);
			this.TimeOut=setTimeout(()=>{
				this.Lista();
			},1000);
		},
		ExportarExcelMaterial(){
			let formData=new FormData();
			formData.set('Materiales',JSON.stringify(this.MaterialesTodos));
			this.DisableBtnExportMaterial=true;
			this.$http.post('proyectomaterial/excel',formData,{
                responseType: 'blob',
            }).then((res)=>{
				let ExcelContent = res.data;
				let file = new Blob([ExcelContent], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				let fileUrl = URL.createObjectURL(file);
				var a = document.createElement('a');
  				a.href = fileUrl;
  				a.download = 'materialesproyecto';
  				document.body.append(a);
  				a.click();
  				a.remove();
  				URL.revokeObjectURL(fileUrl);
			}).finally(()=>{
				this.DisableBtnExportMaterial=false;
			});

		},
		async ImportarExcelMaterial(){
			this.DisableBtnImportMaterial=true;
			let formData=new FormData();
			formData.append('Archivo',this.$refs.excelmaterial.files[0]);
			formData.set('IdProyecto',this.Proyecto.IdProyecto);
			await this.$http.post('proyectomaterial/excelimport',formData,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((res)=>{
				this.$toast.success('Los Materiales se Han Registrado Correctamente');
				this.DisableBtnImportMaterial=false;
			}).catch((err)=>{
				this.DisableBtnImportMaterial=false;
				this.$toast.warning(err.response.data.message);
			}).finally(()=>{
				// this.Archivo='';
				this.Lista();
			})
		},
		SubirArchivoMaterial(){
			const image = this.$refs.excelmaterial.files[0];
			var FileSize = image.size / 1024 / 1024;
			if (FileSize > 1) {
				this.$toast.info('Solo se puede subir archivos menores a 1 MB');
				const  input  = this.$refs.excelmaterial;
                input .type = 'text'
                input .type = 'file';
                return false;
			}
			var allowedExtensions = /(\.xlsx|\.XLSX)$/i;
			if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .xlsx');
                const  input  = this.$refs.excelmaterial;
                input.type = 'text'
                input.type = 'file';
                this.ArchivoMaterial='';
                return false;
            }
			this.ArchivoMaterial=image.name;
		},
		ExportarExcelEquipo(){
			let formData=new FormData();
			formData.set('Equipos',JSON.stringify(this.Equipos));
			formData.set('IdProyecto',this.Proyecto.IdProyecto);
			this.DisableBtnExportEquipo=true;
			this.$http.post('proyectoequipo/excel',formData,{
                responseType: 'blob',
            }).then((res)=>{
				let ExcelContent = res.data;
				let file = new Blob([ExcelContent], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				let fileUrl = URL.createObjectURL(file);
				var a = document.createElement('a');
  				a.href = fileUrl;
  				a.download = 'equiposproyecto';
  				document.body.append(a);
  				a.click();
  				a.remove();
  				URL.revokeObjectURL(fileUrl);
			}).finally(()=>{
				this.DisableBtnExportEquipo=false;
			});

		},
		async ImportarExcelEquipo(){
			this.DisableBtnImportEquipo=true;
			let formData=new FormData();
			formData.append('Archivo',this.$refs.excelequipo.files[0]);
			formData.set('IdProyecto',this.Proyecto.IdProyecto);
			await this.$http.post('proyectoequipo/excelimport',formData,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((res)=>{
				this.$toast.success('Los Equipos se Han Registrado Correctamente');
				this.DisableBtnImportEquipo=false;
			}).catch((err)=>{
				this.DisableBtnImportEquipo=false;
				this.$toast.warning(err.response.data.message);
			}).finally(()=>{
				// this.Archivo='';
				this.Lista();
			})
		},
		SubirArchivoEquipo(){
			const image = this.$refs.excelequipo.files[0];
			var FileSize = image.size / 1024 / 1024;
			if (FileSize > 1) {
				this.$toast.info('Solo se puede subir archivos menores a 1 MB');
				const  input  = this.$refs.excelequipo;
                input .type = 'text'
                input .type = 'file';
                return false;
			}
			var allowedExtensions = /(\.xlsx|\.XLSX)$/i;
			if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .xlsx');
                const  input  = this.$refs.excelequipo;
                input.type = 'text'
                input.type = 'file';
                this.ArchivoEquipo='';
                return false;
            }
			this.ArchivoEquipo=image.name;
		},
		async Lista(){
			this.Filtro.Show=false;
            this.ShowPager=true;
            this.ConfigLoad.ShowLoader=true;
			this.ShowBusqueda=false;
			if (this.Botones.Contratos) {
				await this.$http.get('proyectocontrato/get',{
					params:{
                        IdProyecto:this.Proyecto.IdProyecto,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
				}).then((res)=>{
					this.ListContratos=res.data.data.contratos;
					this.RutaPdfContrato=res.data.ruta;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
				}).finally(()=>{
					this.ConfigLoad.ShowLoader=false;
				})
			}
			if (this.Botones.Facturacion) {
				await this.$http.get('proyectofactura/get',{
					params:{
                        IdProyecto:this.Proyecto.IdProyecto,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
				}).then((res)=>{
					this.ListFacturas=res.data.data.facturas;
					this.RutaFileFactura 		= res.data.RutaFileOrg;
					this.RutaFileCtaCobrar 		= res.data.RutaFileCtaCobrar;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
				}).finally(()=>{
					this.ConfigLoad.ShowLoader=false;
				})
			}
			if (this.Botones.Compras) {
				this.Filtro.Show=true;
				await this.$http.get('proyectocuenta/get',{
					params:{
                        IdProyecto:this.Proyecto.IdProyecto,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina,
						IdProveedor:this.IdProveedor
                    }
				}).then((res)=>{
					this.ListCuentas=res.data.data.cuentas;
					this.TotalCuentas=res.data.data.total;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
				}).finally(()=>{
					this.ConfigLoad.ShowLoader=false;
				})
			}
			if (this.Botones.Estimaciones) {
				await this.$http.get('proyectoestimacion/get',{
					params:{
                        IdProyecto:this.Proyecto.IdProyecto,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
				}).then((res)=>{
					this.ListProyectoEstimaciones=res.data.data.proyectoestimacion;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
				}).finally(()=>{
					this.ConfigLoad.ShowLoader=false;
				})
			}
			if (this.Botones.Adicionales) {
				await this.$http.get('proyectoadicion/get',{
					params:{
                        IdProyecto:this.Proyecto.IdProyecto,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
				}).then((res)=>{
					this.ListProyectoAdicionales=res.data.data.proyectoadicion;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
				}).finally(()=>{
					this.ConfigLoad.ShowLoader=false;
				})
			}
			if (this.Botones.ReporteObra) {
				this.ListProyectoReporteObras=[];
				this.ListProyectoReporteObrasCompleto=[];
				await this.$http.get('proyectoreporteobra/get',{
					params:{
                        IdProyecto:this.Proyecto.IdProyecto,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
				}).then((res)=>{
					this.ListProyectoReporteObras=res.data.data.proyectoreporteobra;
					this.ListProyectoReporteObrasCompleto=res.data.data.proyectoreporteobracompleto;
					this.RutaReporteObra1=res.data.data.rutareporteobra1;
					this.RutaReporteObra2=res.data.data.rutareporteobra2;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
				}).finally(()=>{
					this.ConfigLoad.ShowLoader=false;
				})
			}
			if (this.Botones.Propuestas) {
				await this.$http.get('proyectopropuesta/get',{
					params:{
                        IdProyecto:this.Proyecto.IdProyecto,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
				}).then((res)=>{
					this.ListProyectoPropuestas=res.data.data.propuestas;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
				}).finally(()=>{
					this.ConfigLoad.ShowLoader=false;
				})
			}
			if (this.Botones.Personal) {
				await this.$http.get('proyectopersonal/get',{
					params:{
                        IdProyecto:this.Proyecto.IdProyecto,
                        Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
				}).then((res)=>{
					this.ListProyectoPersonal=res.data.data.proyectopersonal;
					this.RutaFotoProyectoPersonal=res.data.data.rutaproyectopersonal;
					this.RutaFotoTrabajador=res.data.data.rutatrabajador;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
				}).finally(()=>{
					this.ConfigLoad.ShowLoader=false;
				})
			}
			if (this.Botones.Documentos) {
				this.Filtro.Show=true;
				await this.$http.get('proyectodocumento/get',{
					params:{
                        IdProyecto:this.Proyecto.IdProyecto,
                        Tipo:this.Filtro.Tipo,
						Entrada:this.Filtro.Entrada,
                        pag:this.Filtro.Pagina
                    }
				}).then((res)=>{
					this.ListProyectoDocumentos=res.data.data.proyectodocumento;
					this.RutaProyectoDocumento=res.data.data.rutaproyectodocumento;
                    this.Filtro.Entrada=res.data.data.pagination.PageSize;
                    this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
				}).finally(()=>{
					this.ConfigLoad.ShowLoader=false;
				})
			}
			if (this.Botones.Garantias) {
				await this.$http.get('servicio/get',{
					params:{
						IdConfigS:5,
						EstatusS:'CERRADA',
						Contratos:this.Proyecto.Contratos,
						pag:this.Filtro.Pagina,
                        Entrada:this.Filtro.Entrada
					}
				}).then((res)=>{
					this.ListGarantias=res.data.data.servicio;
                    this.Filtro.Entrada = res.data.data.pagination.PageSize;
					this.Filtro.TotalItem = res.data.data.pagination.TotalItems;
				}).finally(()=>{
					this.ConfigLoad.ShowLoader=false;
				})
			}
			if (this.Botones.Servicios) {
				await this.$http.get('servicio/get',{
					params:{
						EstatusS:'CERRADA',
						Contratos:this.Proyecto.Contratos,
						pag:this.Filtro.Pagina,
                        Entrada:this.Filtro.Entrada
					}
				}).then((res)=>{
					this.ListGarantias=res.data.data.servicio;
                    this.Filtro.Entrada = res.data.data.pagination.PageSize;
					this.Filtro.TotalItem = res.data.data.pagination.TotalItems;
				}).finally(()=>{
					this.ConfigLoad.ShowLoader=false;
				})
			}
			if (this.Botones.Planos) {
				this.ShowBusqueda=true;
				this.Filtro.Show=true;
				await this.$http.get('proyectoplano/get',{
					params:{
						Nombre:this.Filtro.Nombre,
						IdProyecto:this.Proyecto.IdProyecto,
						Tipo:this.Filtro.Tipo,
						pag:this.Filtro.Pagina,
                        Entrada:this.Filtro.Entrada
					}
				}).then((res)=>{
					this.ListProyectoPlanos=res.data.data.proyectoplano;
					this.RutaProyectoPlano=res.data.data.rutaarchivo;
                    this.Filtro.Entrada = res.data.data.pagination.PageSize;
					this.Filtro.TotalItem = res.data.data.pagination.TotalItems;
				}).finally(()=>{
					this.ConfigLoad.ShowLoader=false;
				})
			}
			if (this.Botones.Materiales) {
				this.Filtro.Show=true;
				await this.$http.get('proyectomaterial/get',{
					params:{
						Nombre:this.Filtro.Nombre,
						IdProyecto:this.Proyecto.IdProyecto,
						// Tipo:this.Filtro.Tipo,
						pag:this.Filtro.Pagina,
                        Entrada:this.Filtro.Entrada,
						Estatus:this.Filtro.Estatus
					}
				}).then((res)=>{
					this.Materiales=res.data.data.proyectomaterial;
					this.MaterialesTodos=res.data.data.todos;
					this.Filtro.Entrada = res.data.data.pagination.PageSize;
					this.Filtro.TotalItem = res.data.data.pagination.TotalItems;
				}).finally(()=>{
					this.ConfigLoad.ShowLoader=false;
				})
			}
			if (this.Botones.Equipos) {
				this.Filtro.Show=true;
				await this.$http.get('proyectoequipo/get',{
					params:{
						Nombre:this.Filtro.Nombre,
						IdProyecto:this.Proyecto.IdProyecto,
						// Tipo:this.Filtro.Tipo,
						pag:this.Filtro.Pagina,
                        Entrada:this.Filtro.Entrada,
						Estatus:this.Filtro.Estatus
					}
				}).then((res)=>{
					this.Equipos=res.data.data.proyectoequipo;
					this.Filtro.Entrada = res.data.data.pagination.PageSize;
					this.Filtro.TotalItem = res.data.data.pagination.TotalItems;
				}).finally(()=>{
					this.ConfigLoad.ShowLoader=false;
				})
			}
		},
		async AddMaterial(Obj){
			let Material={
				IdProyecto:this.Proyecto.IdProyecto,
				IdMaterial:Obj.IdMaterial,
				CodigoEmpresa:Obj.Codigo,
				CodigoFabricante:Obj.CodigoFabricante,
				Item:Obj.Item,
				Unidad:Obj.Unidad,
				Marca:Obj.Marca,
				Modelo:Obj.Modelo,
				Factura:'',
				Presupuesto:Obj.Precio,
				Comprometido:0,
				Adquirido:0,
				Cantidad:0,
				Requerido:null,
				Compra:null,
				Estatus:3,
				Descripcion:Obj.NomMaterial,
				Imagen:Obj.Imagen,
			}
			await this.$http.post('proyectomaterial/post',Material).then((res)=>{
				this.$toast.success('Material Agregado Correctamente');
				$('#MaterialAdd').modal('hide');
				this.Lista();
			});
		},
		async AddEquipo(Obj){
			let Equipo={
				IdProyecto:this.Proyecto.IdProyecto,
				IdEquipoCot:Obj.IdEquipoCot,
				CodigoEmpresa:Obj.Codigo,
				CodigoFabricante:Obj.CodigoFabricante,
				Item:Obj.Item,
				Unidad:Obj.Unidad,
				Marca:Obj.Marca,
				Modelo:Obj.Modelo,
				Factura:'',
				Presupuesto:Obj.Precio,
				Comprometido:0,
				Adquirido:0,
				Cantidad:0,
				Requerido:null,
				Compra:null,
				Estatus:3,
				Descripcion:Obj.Nombre,
				Imagen:Obj.Imagen,
			}
			await this.$http.post('proyectoequipo/post',Equipo).then((res)=>{
				this.$toast.success('Material Agregado Correctamente');
				$('#EquipoAdd').modal('hide');
				this.Lista();
			});
		},
		async GetProyecto(){
			this.ShowGraficaProgreso=false;
			this.ShowGraficaPresupuesto=false;
			await this.$http.get('proyectos/recoverytarjeta',{
				params:{
					IdProyecto:this.Proyecto.IdProyecto
				}
			}).then((res)=>{
				this.Proyecto=res.data.data.proyecto;
				this.RutaImagen=res.data.data.UrlImagen;
				this.RutaImagenExtra=res.data.data.UrlImagenExtra;
				this.ValoresCard.Venta=res.data.data.Venta;
				this.ValoresCard.VentaPorcen=res.data.data.VentaPorcen;
				this.ValoresCard.CostoOperativo=res.data.data.CostoOperativo;
				this.ValoresCard.CostoOperativoPorcen=res.data.data.CostoOperativoPorcen;
				this.ValoresCard.Facturado=res.data.data.Facturado;
				// this.ValoresCard.Facturado=10000;
				this.ValoresCard.FacturadoPorcen=res.data.data.FacturadoPorcen;
				this.ValoresCard.Estimado=res.data.data.Estimado;
				this.ValoresCard.EstimadoPorcen=res.data.data.EstimadoPorcen;
				this.ValoresCard.GastoOp=res.data.data.GastoOp;
				this.ValoresCard.GastoOpPorcen=res.data.data.GastoOpPorcen;
				this.ValoresCard.Cobrado=res.data.data.Cobrado;
				// this.ValoresCard.Cobrado=8000;
				this.ValoresCard.CobradoPorcen=res.data.data.CobradoPorcen;
				this.ValoresCard.Retencion=res.data.data.Retencion;
				this.ValoresCard.RetencionPorcen=res.data.data.RetencionPorcen;
				this.UtilidadActual=res.data.data.UtilidadActual;
				this.SeriesProgreso[0]=res.data.data.Progreso;
				this.SeriesPresupuesto[0]=res.data.data.Presupuesto;
				this.ShowGraficaProgreso=true;
				this.ShowGraficaPresupuesto=true;
				this.Venta=res.data.data.ObjVenta;
				let Imagen = res.data.data.proyecto.Imagen;
				if (Imagen != "" && Imagen != null) {
					this.Proyecto.Imagen = res.data.data.UrlImagen + this.Proyecto.Imagen;
				}
				this.Lista();
				// if (ImagenExtra != "" && ImagenExtra != null) {
				// 	this.Proyecto.ImagenExtra = res.data.data.UrlImagenExtra + this.Proyecto.ImagenExtra;
				// }
				// this.readURL(this.Proyecto.Imagen);
			})
		},
		CambiarImagenProyecto(target){
			if (this.ContadorImagenProyecto==0) {
				this.$uploadImagePreview(target,this.ValidElement, Array('Img','imagePreview'));
				if(this.$refs.file.files[0]!=undefined){
					this.ContadorImagenProyecto++;
					this.BndImagen=1;
					this.ObjImagen=this.$refs.file.files;
				}
				else{
					this.BndImagen=0;
				}
			}
			else{
				this.$uploadImagePreview(target,this.ValidElement, Array('Img','imagePreview'));
				if(this.$refs.file.files[0]==undefined){
					this.$refs.file.files=this.ObjImagen;
				}
				else{
					this.ObjImagen=this.$refs.file.files;
				}
			}
		},
		CambiarImagenExtra(target){
			if (this.ContadorImagenExtra==0) {
				this.$uploadImagePreview(target,this.ValidElement, Array('Img','ImagePreviewExtra'));
				if(this.$refs.file2.files[0]!=undefined){
					this.BndImagenExtra=1;
					this.ContadorImagenExtra++;
					this.ObjImagenExtra=this.$refs.file2.files;
				}
				else{
					this.BndImagenExtra=0;
				}
			}
			else{
				this.$uploadImagePreview(target,this.ValidElement, Array('Img','ImagePreviewExtra'));
				if(this.$refs.file2.files[0]==undefined){
					this.$refs.file2.files=this.ObjImagenExtra;
				}
				else{
					this.ObjImagenExtra=this.$refs.file2.files;
				}
			}
		},
		CambiarBanderaImagen(){
			this.BndImagen=1;
		},
		CambiarBanderaImagenExtra(){
			this.BndImagenExtra=1;
		},
		ZoomImagen(Imagen,camino){
			switch (camino) {
				case 1:
					if (this.$refs.file.files[0]!=undefined) {
						let ImagenPreview=document.getElementById("imagePreview");
						const Estilos=window.getComputedStyle(ImagenPreview);
						let CadenaBase=Estilos.backgroundImage;
						let Url=CadenaBase.slice(5,-2);
						this.ImagenAMostrar=Url;
					}
					else{
						this.ImagenAMostrar=Imagen;
					}
					break;
				case 2:
					if (this.$refs.file2.files[0]!=undefined){
						let ImagenPreview=document.getElementById("ImagePreviewExtra");
						const Estilos=window.getComputedStyle(ImagenPreview);
						let CadenaBase=Estilos.backgroundImage;
						let Url=CadenaBase.slice(5,-2);
						this.ImagenAMostrar=Url;
					}
					else{
						this.ImagenAMostrar=Imagen;
					}
					break;
			}
		},
		GuardarImagen(){
			let formData=new FormData();
			let image=this.$refs.file.files[0];
			if (image!=undefined) {
				if (this.Proyecto.Imagen!=null) {
					let index=this.Proyecto.Imagen.lastIndexOf("/")+1;
					let cadena=this.Proyecto.Imagen.substr(index);
					formData.set('ImagenPreviaProyecto','/'+cadena);	
				}
				formData.set('IdProyecto',this.Proyecto.IdProyecto);
				formData.append('Imagen',image);
				this.RutaImagen=image.name;
				this.$http.post('proyecto/imagen/post',formData,{
					'Content-Type':'multipart/form-data'
				}).then((res)=>{
					this.$toast.success("Imagen guardada");
					// this.bus.$emit('ActualizarImagen',res.data.data.proyecto.Imagen);
					this.BndImagen=0;
				});
			}
			else{
				this.$toast.info("Tienes que subir una imagen");
			}
		},
		GuardarImagenExtra(){
			let formData=new FormData();
			let image=this.$refs.file.files[0];
			if (image!=undefined) {
				if (this.Proyecto.ImagenExtra!=null) {
					let index=this.Proyecto.ImagenExtra.lastIndexOf("/")+1;
					let cadena=this.Proyecto.ImagenExtra.substr(index);
					formData.set('ImagenExtraPreviaProyecto','/'+cadena);	
				}
				formData.set('IdProyecto',this.Proyecto.IdProyecto);
				formData.append('ImagenExtra',image);
				this.RutaImagenExtra=image.name;
				this.$http.post('proyecto/imagenextra/post',formData,{
					'Content-Type':'multipart/form-data'
				}).then((res)=>{
					this.$toast.success("Imagen guardada");
					this.bus.$emit('ActualizarImagenExtra',res.data.data.proyecto.ImagenExtra);
					this.BndImagenExtra=0;
				});
			}
			else{
				this.$toast.info("Tienes que subir una imagen");
			}
		},
		CambiarPestania(index){
			this.Filtro.Tipo='';
			this.Filtro.Estatus='';
			this.Filtro.Pagina=1;
			let Botones=this.Botones;
			Object.keys(Botones).forEach(function(key,ind){
				if (key==index) {
					Botones[key]=true;
				}
				else{
					Botones[key]=false;
				}
				// console.log(index)
			});
			this.Lista();
		},
		EliminarEstimacion(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'proyectoestimacion/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                    })
                }
            })
        },
		EliminarAdicion(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'proyectoadicion/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
						this.bus.$emit('List');
                    })
                }
            })
        },
		EliminarReporteObra(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'proyectoreporteobra/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
						this.bus.$emit('List');
                    })
                }
            })
        },
		EliminarDocumento(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'proyectodocumento/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                    })
                }
            })
        },
		EliminarPlano(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'proyectoplano/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                    })
                }
            })
        },
		EliminarPersonal(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'proyectopersonal/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                    })
                }
            })
        },
		EliminarMaterial(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'proyectomaterial/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                    })
                }
            })
        },
		EliminarEquipo(Id){
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'proyectoequipo/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.bus.$emit('ListaPrincipal');
                    })
                }
            })
        },
		NuevoContrato(){
			this.bus.$emit('NewModal_'+this.ConfigModalContrato.EmitSeccion,true,0,this.Proyecto.IdProyecto);
		},
		NuevoEstimacion(){
			this.bus.$emit('NewModal_'+this.ConfigModalEstimacion.EmitSeccion,true,0,this.Proyecto.IdProyecto);
		},
		NuevoAdicion(){
			this.bus.$emit('NewModal_'+this.ConfigModalAdicion.EmitSeccion,true,0,this.Proyecto.IdProyecto);
		},
		NuevoReporteObra(){
			this.bus.$emit('NewModal_'+this.ConfigModalReporteObra.EmitSeccion,true,0,this.Proyecto.IdProyecto);
		},
		NuevoPlano(){
			this.bus.$emit('NewModal_'+this.ConfigModalPlano.EmitSeccion,true,0,this.Proyecto.IdProyecto);
		},
		NuevoPersonal(){
			this.bus.$emit('NewModal_'+this.ConfigModalPersonal.EmitSeccion,true,0,this.Proyecto.IdProyecto);
		},
		NuevoDocumento(){
			this.bus.$emit('NewModal_'+this.ConfigModalDocumento.EmitSeccion,true,0,this.Proyecto.IdProyecto);
		},
		EditarMaterial(Id){
			this.bus.$emit('NewModal_'+this.ConfigModalMaterialForm.EmitSeccion,true,Id,this.Proyecto.IdProyecto);
		},
		EditarEquipo(Id){
			this.bus.$emit('NewModal_'+this.ConfigModalEquipoForm.EmitSeccion,true,Id,this.Proyecto.IdProyecto);
		},
		EditarCuenta(Id){
			this.bus.$emit('Nuevo',0,Id);
		},
		Observation(id) {
			this.bus.$emit("UploadO", id);
		},
		formateoMillon(numero){
            let fixed = 0;
			let e=0;
			if (numero === null) {
				return null;
			} // terminate early
			if (numero === 0) {
				return "0";
			} // terminate early
			fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
			var b = numero.toPrecision(2).split("e"), // get power
				k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 6), // floor at decimals, ceiling at trillions
				c =
					k < 1
						? numero.toFixed(0 + fixed)
						: (numero / Math.pow(10, k * 6)).toFixed(1 + fixed), // divide by power
				d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
				if (k==0) {
					// e=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',roundingPriority:'morePrecision'}).format(d);
					e=d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
				}
				else{
					e = d + ["", " M", " B", " T"][k]; // append power
				}
			return e;
        },
		EvalConfigS(IdConfigS){
			let Cadena='';
			switch (IdConfigS) {
				case "1":
					Cadena='Mantenimiento';
					break;
				case "2":
					Cadena='Servicio';
					break;
				case "3":
					Cadena='Proyecto';
					break;
			}
			return Cadena;
		},
		DescargarFactura(IdFactura){
            if (IdFactura !='' || IdFactura !=null)
            {
                this.$http.get(
                    'reporte/factura',
                    {
                    responseType: 'blob',
                    params :{
                            IdFactura:IdFactura,
                        }
                    }
                ).then( (response) => {

                    let pdfContent = response.data;
                    let file = new Blob([pdfContent], { type: 'application/pdf' });
                    let fileUrl = URL.createObjectURL(file);
                    window.open(fileUrl);
                });
            }
        },
		DescargarPdfReal(nombre)
        {
            let pdfWindow = window.open(this.RutaFileFactura+nombre);
            pdfWindow.document.write("<iframe width='100%' height='100%' src='" + this.RutaFileFactura+nombre +"'></iframe>");
        },
        DescargarReciboPago(nombre)
        {
            let pdfWindow = window.open(this.RutaFileCtaCobrar+nombre);
            pdfWindow.document.write("<iframe width='100%' height='100%' src='" + this.RutaFileCtaCobrar+nombre +"'></iframe>");
        },
		AbrirPdf(Nombre){
			// console.log(Nombre)
			let pdfWindow = window.open(Nombre);
            pdfWindow.document.write("<iframe width='100%' height='100%' src='" + Nombre +"'></iframe>");
		},
		EvalNumPagos(Num){
			let Cadena='';
			switch (Num) {
				case '1':
					Cadena='1 Pago';
					break;
				case '2':
					Cadena='2 Pagos';
					break;
				case '3':
					Cadena='3 Pagos';
					break;
				case '4':
					Cadena='4 Pagos';
					break;
				case '5':
					Cadena='Estimados';
					break;
				case '6':
					Cadena='Mensual';
					break;
				case '7':
					Cadena='Bimestral';
					break;
				case '8':
					Cadena='Trimestral';
					break;
			}
			return Cadena;
		},
		EvalEstatusAlmacenNombre(Estatus){
			let Cadena='';
			switch (Estatus) {
				case '1':
					Cadena='Comprado';
					break;
				case '2':
					Cadena='Proceso de Compra';
					break;
				case '3':
					Cadena='Pendiente';
					break;
				case '4':
					Cadena='No Disponible';
					break;
				case '5':
					Cadena='Cancelado';
					break;
			}
			return Cadena;
		},
		EvalEstatusAlmacen(Estatus){
			let Cadena='';
			switch (Estatus) {
				case '1':
					Cadena='circuloStatusOperando';
					break;
				case '2':
					Cadena='circuloStatusServicio';
					break;
				case '3':
					Cadena='circuloStatusNeutro';
					break;
				case '4':
					Cadena='circuloStatusObservacion';
					break;
				case '5':
					Cadena='circuloStatusFueraServicio';
					break;
			}
			return Cadena;
		},
		EvalEstatusDia(Estatus){
			let Cadena='';
			switch (Estatus) {
				case '1':
					Cadena='circuloStatusOperando';
					break;
				case '2':
					Cadena='circuloStatusObservacion';
					break;
				case '3':
					Cadena='circuloStatusFueraServicio';
					break;
			}
			return Cadena;
		},
		EvalItemReporte(Item){
			let Cadena='';
			switch (Item) {
				case '1':
					Cadena='Instalación Mecánica';
					break;
				case '2':
					Cadena='Instalación Control';
					break;
				case '3':
					Cadena='Instalación Eléctrica';
					break;
				case '4':
					Cadena='Montaje Equipos';
					break;
				case '5':
					Cadena='Limpieza';
					break;
				case '6':
					Cadena='Trabajos Civiles';
					break;
				case '7':
					Cadena='Seguridad';
					break;
				case '8':
					Cadena='Retrabajo / Garantía';
					break;
				case '9':
					Cadena='Otros';
					break;
				default:
					Cadena=Item;
					break;
			}
			return Cadena;
		},
		EvalAtraso(Atraso){
			let Cadena='';
			switch (Atraso) {
				case '1':
					Cadena='SI';
					break;
				case '2':
					Cadena='NO';
					break;
			}
			return Cadena;
		},
		EvalTipoDocumento(Tipo){
			let Cadena='';
			switch (Tipo) {
				case '1':
					Cadena='Personal';
					break;
				case '2':
					Cadena='Contratista';
					break;
				case '3':
					Cadena='RFI';
					break;
				case '4':
					Cadena='Seguridad';
					break;
			}
			return Cadena;
		},
		GetTipoPlano(Tipo){
			let Cadena='';
			switch (Tipo) {
				case '1':
					Cadena='Plano de Sitio';
					break;
				case '2':
					Cadena='Plano de Planta';
					break;
				case '3':
					Cadena='Plano de Elevación';
					break;
				case '4':
					Cadena='Plano de Corte';
					break;
				case '5':
					Cadena='Plano de Detalle';
					break;
				case '6':
					Cadena='Plano Estructural';
					break;
				case '7':
					Cadena='Planos MEP';
					break;
				case '8':
					Cadena='Planos de Acabados';
					break;
				case '9':
					Cadena='Planos de Taller';
					break;
			}
			return Cadena;
		},
		AbrirCotizacionCliente(IdCotizacion){
			this.$http.get('reporte/cotizacioncliente',
            {
                responseType: 'blob',
                params :{
                        key:IdCotizacion,
                    }
            }).then( (response) => {
                let pdfContent = response.data;
                let file = new Blob([pdfContent], { type: 'application/pdf' });
                let fileUrl = URL.createObjectURL(file);

                window.open(fileUrl);
            });
		},
		DescargarReporte(IdServicio){
            let spinner=document.getElementById(`pdfOrden_${IdServicio}`);
			spinner.setAttribute('class','fa fa-spinner fa-pulse fa-1x fa-fw');
			this.$http.get('reporte/servicio',
            {
                responseType: 'blob',
                params :
                    {
                        IdServicio:IdServicio,
                    }
            }).then( (response) => {

                let pdfContent = response.data;
                let file = new Blob([pdfContent], { type: 'application/pdf' });
                let fileUrl = URL.createObjectURL(file);
                window.open(fileUrl);
                spinner.setAttribute('class','fas fa-file-pdf fa-fw-m');

            });
        },
        DescargarEvidencia(IdServicio){
            this.$router.push({name:'mon_evidencia',
                params:{
                    IdServicio:IdServicio,
                    isMonitoreo:false,
                    isContacto:false,
					isProyecto:true,
                }
            });
        },
		GetProveedores(){
			this.$http.get('ctaproveedores/get').then((res)=>{
				this.ListaProveedores=res.data.data.todos.map((value) => {
					return {
						id:value.IdProveedor,
						label:value.Nombre
					}
				});
			})
		},
		DefinirClaseCheck(Status){
            let Clase="";
            switch (Status) {
                case "Puntual":
                    Clase="circuloStatusOperando";
                    break;
                case "Tolerancia":
                    Clase="circuloStatusObservacion";
                    break;
                case "Atraso":
                    Clase="circuloStatusFueraServicio";
                    break;
				case "Falta":
                    Clase="circuloStatusNegro";
                    break;
                case "Horas Extra":
                    Clase="circuloStatusAzul";
                    break;
                case "Hora Extra":
                    Clase="circuloStatusAzul";
                    break;
                case "Vacaciones":
                    Clase="circuloStatusServicio";
                    break;
                default:
                    Clase="circuloStatusDefault";
                    break;
            }
            return Clase;
        },
		Calendario(){
			this.$router.push({name:'calendar',params:{pOrigen:'proyecto',pProyecto:this.Proyecto}});
		},
		IrSpendPlan(){
			this.$router.push({name:'spendproyectomantenimiento',params:{pVenta:this.Venta,pAccion:'editar',pOrigen:'proyecto'}});
		},
		IrDashboard(){
			this.$router.push({name:'proyectodashboard',params:{pIdProyecto:this.Proyecto.IdProyecto}});
		},
		EvalUtilidadActual(UtilidadActual){
			let Cadena='';
			if (UtilidadActual<=0) {
				Cadena='bold text-danger';
			}
			else{
				Cadena='bold text-success';
			}
			return Cadena;
		},
		ComparacionCifrasColor(CifraEntera,CifraComparar){
			let Cadena='';
			let CifraCondicionBlanco=CifraEntera*0.90;
			let CifraCondicionAmarillo=CifraEntera*0.80;
			let CifraCondicionNaranja=CifraEntera*0.50;
			if (CifraEntera==0 || CifraComparar>=CifraCondicionBlanco) {
				Cadena='';
			}
			else if (CifraComparar>=CifraCondicionAmarillo && CifraComparar<CifraCondicionBlanco) {
				Cadena='text-yellow';
			}
			else if (CifraComparar>=CifraCondicionNaranja && CifraComparar<CifraCondicionAmarillo) {
				Cadena='text-orange';
			}
			else{
				Cadena='text-danger';
			}
			return Cadena;
		}
	},
	created() {
		if (this.IdProyecto!=undefined) {
			sessionStorage.setItem("IdProyecto",this.IdProyecto);
		}
		this.GetProveedores();
		this.Proyecto.IdProyecto=sessionStorage.getItem("IdProyecto");
		this.bus.$off('ListaPrincipal');
        this.bus.$on('ListaPrincipal',()=>{
            this.Lista();
        });
		this.bus.$off('Add_Materiales');
        this.bus.$on('Add_Materiales',(Obj)=>{
			this.AddMaterial(Obj);
        });
		this.bus.$off('Add_Equipos');
        this.bus.$on('Add_Equipos',(Obj)=>{
			this.AddEquipo(Obj);
        });
		this.bus.$off('List');
        this.bus.$on('List',()=>{
            this.GetProyecto();
        });
		this.bus.$off('Delete_'+this.ConfigModalEstimacion.EmitSeccion);
        this.bus.$on('Delete_'+this.ConfigModalEstimacion.EmitSeccion,(Id)=>{
            this.EliminarEstimacion(Id);
        });
		this.bus.$off('Delete_'+this.ConfigModalAdicion.EmitSeccion);
        this.bus.$on('Delete_'+this.ConfigModalAdicion.EmitSeccion,(Id)=>{
            this.EliminarAdicion(Id);
        });
		this.bus.$off('Delete_'+this.ConfigModalReporteObra.EmitSeccion);
        this.bus.$on('Delete_'+this.ConfigModalReporteObra.EmitSeccion,(Id)=>{
            this.EliminarReporteObra(Id);
        });
		this.bus.$off('Delete_'+this.ConfigModalDocumento.EmitSeccion);
        this.bus.$on('Delete_'+this.ConfigModalDocumento.EmitSeccion,(Id)=>{
            this.EliminarDocumento(Id);
        });
		this.bus.$off('Delete_'+this.ConfigModalPersonal.EmitSeccion);
        this.bus.$on('Delete_'+this.ConfigModalPersonal.EmitSeccion,(Id)=>{
            this.EliminarPersonal(Id);
        });
		this.bus.$off('Delete_'+this.ConfigModalPlano.EmitSeccion);
        this.bus.$on('Delete_'+this.ConfigModalPlano.EmitSeccion,(Id)=>{
            this.EliminarPlano(Id);
        });
		this.bus.$off('Regresar');
		this.bus.$on('Regresar',()=>{
			if (this.IdContratoMaster>0) {
				this.$router.push({name:'proyectosrelacionados'});
			}
			else{
				this.$router.push({name:'proyectoslist'})
			}
		})
		this.bus.$off('SwitchModalDocumentSize');
		this.bus.$on('SwitchModalDocumentSize',(Tipo)=>{
			switch (Tipo) {
				case '3':
					this.ConfigModalDocumento.Size='modal-lg';
					break;
				default:
					this.ConfigModalDocumento.Size='modal-md';
					break;
			}
		});
	},
	mounted() {
		this.GetProyecto();
	},
}
</script>

<style>

</style>
